import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'

Vue.use(MLInstaller)

export default new MLCreate({
  initial: 'Türkçe',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('Türkçe').create({
      title: 'Merhaba {0}!',
      general: {
        addNew: "Yeni Ekle",
        select2: "Seç",
        select: "Seçiniz",
        notSelected: "Seçilmedi",
        selected: "Seçildi",
        notChanged: "Değiştirilmedi",
        active: "Aktif",
        passive: "Pasif",
        isActive: "Kayıt Aktif mi?",
        exportToPdfOrPrint: "PDF Aktar / Yazdır",
        exportToExcel: "Excele Aktar",
        view: "Görüntüle",
        remove: "Kaldır",
        all: "Tümü",
        selectAll: "Tümünü Seç",
        removeAll: "Tümünü Kaldır",
        add: "Ekle",
        added: "Eklendi",
        close: "Kapat",
        done: "Tamam",
        doorOpen: "Kapı Açık",
        doorIsClosed: "Kapı Kapalı",
        connected: "Bağlı",
        notConnected: "Bağlı Değil",
        refreshScreen: "Ekranı Yenile",
        removed: "Çıkartıldı",
        cancel: "İptal",
        save: "Kaydet",
        update: "Güncelle",
        credit: "Kontör",
        balance: "Bakiye",
        delete: "Sil",
        confirm: "Onayla",
        apply: "Uygula",
        monday: "Pazartesi",
        tuesday: "Salı",
        wednesday: "Çarşamba",
        thursday: "Perşembe",
        friday: "Cuma",
        saturday: "Cumartesi",
        sunday: "Pazar",
        search: "Arama yapın...",
        viewQRCode: "QR Kodu Görüntüle",
        qRCodeBarcodePrint: "QR Kod & Barkod Yazdır",
        qrSettings: "QR Ayarları",
        qrSize: "Boyut",
        print: "Yazdır",
        upload: "Yükle",
        download: "İndir"
      },
      shared: {
        myProfile: "Profilim",
        company: "Şirket",
        languageOptions: "Dil Seçenekleri",
        changeLanguageInfo: "Değiştirmek istediğiniz dili seçin.",
        licenceErrorTitle: "Lisans Hatası",
        licenceError: "Lisans Anahtarı Geçersiz!",
        softwareKey: "Yazılım Anahtarı",
        softwareKeyDescription: "Bu kodu satın aldığınız yere iletin.",
        enterLicenceKey: "Lisans Anahtarı Girin",
        licenceKeyDescription: "Satın almış olduğunuz ürüne ait lisans numaranızı girin.",
        saveLicenceKey: "Lisans Anahtarını Kaydet",
        wrongLicenceKey: "Lütfen geçerli bir lisans numarası girin",
        saveLicenceKeySuccessfully: "Lisans anahtarı başarıyla kaydedildi!",
        licenceAddTerminalMaxCount: "Varolan lisansınıza maksimum eklenebilecek terminal sayısı",
        licenceTerminalDescription: "Yeni terminal ekleyebilmek için lisansınızı yükseltmeniz gerekmektedir. Lisansınızı yükseltmek için lütfen satıcınızla irtibata geçin.",
        theme: "Tema",
        themes: {
          blue: "Mavi",
          black: "Siyah",
          purple: "Mor",
          green: "Yeşil",
          red: "Kırmızı",
          yellow: "Turuncu",
          blueLight: "Mavi Beyaz",
          blackLight: "Siyah Beyaz",
          purpleLight: "Mor Beyaz",
          greenLight: "Yeşil Beyaz",
          redLight: "Kırmızı Beyaz",
          yellowLight: "Turuncu Beyaz"
        },
        manufacturerInformation: "Üretici Bilgileri",
        copyright: "Telif Hakkı",
        allRightsReserved: "Tüm hakları saklıdır.",
        version: "Versiyon",
        notifications: "Bildirimler",
        deviceCommunication: "Terminal İletişim",
        notificationNotFound: "Kullanıcıya ait bildirim bulunmamaktadır.",
        notificationView: "Toplam görüntülenen bildirim :",
        logOut: "Çıkış Yap",
        dashboard: "Kontrol Paneli",
        realTimeMonitor: "Canlı İzleme",
        employees: "Kişiler",
        visitors: "Ziyaretçi Takip",
        visitorCards: "Ziyaretçi Kartları",
        visitorReports: "Ziyaretçi Raporları",
        batchOperations: "Toplu İşlemler",
        reports: "Raporlar",
        payrollManagement: "Puantaj Yönetimi",
        shiftManagement: "Vardiya (Shift) Yönetimi",
        shiftSettings: "Vardiya (Shift) Ayarları",
        diningHall: "Yemekhane",
        retailSale: "Bakiyeli Satış",
        employeeOperations: "Kişi İşlemleri",
        studentTransactions: "Öğrenci İşlemleri",
        areas: "Bölgeler",
        foodGroups: "Yemek Grupları",
        diningHallReports: "Yemekhane Raporları",
        guardTourSystem: "Devriye Tur Kontrol",
        guards: "Görevliler",
        points: "Kontrol Noktaları",
        tours: "Turlar",
        guardTourReports: "Devriye Tur Raporları",
        definitions: "Tanımlamalar",
        cardDesignTemplates: "Kart Şablonları",
        extraFields: "Özel Alanlar",
        licensePlateRecognition: "Plaka Tanıma Sistemi",
        departments: "Departmanlar",
        accessGroups: "Geçiş Yetki Grupları",
        workPlans: "Çalışma Planları",
        overtimeDefinitions: "Fazla Mesai Tanımları",
        allowences: "İzinler",
        annualPermitGroups: "Yıllık İzin Grupları",
        scenarioList: "Senaryo Listesi",
        timeZones: "Geçiş Parametreleri",
        devices: "Terminaller",
        deviceOperations: "Terminal İşlemleri",
        settings: "Ayarlar",
        companySettings: "Şirket Ayarları",
        users: "Kullanıcılar",
        userAuthorityGroups: "Yetki Grupları",
        mailSmsSettings: "Mail & SMS Ayarları",
        userLogs: "İşlem Kayıtları ",
        payrollTypes: "Puantaj Tipleri",
        monthlyPayrollTables: "Aylık Puantaj Tablosu",
        integration: "Entegrasyon",
        support: "Destek",
        appAbout: "Yazılım Hakkında",
        workPlaceDefinitions:"Görev Yeri Tanımları",
        inventoryManagement: "Demirbaş Yönetimi",
        inventoryCategories: "Demirbaş Kategorileri",
        inventoryWarehouses: "Demirbaş Depoları",
        inventoryFields: "Demirbaş Özellikleri",
        inventories: "Demirbaşlar",
        documentDefinitions:"Belge Tanımları",
      },
      filters: {
        filterEmployees: "Kişileri Filtrele",
        filterNameSurnameOrCardNo: "Adı Soyadı / Kart No",
        filterCitizenshipNumber: "Vatandaşlık No",
        filterRegistrationOrDeviceNo: "Sicil No / Terminal No",
        filterDocumentNoOrEmail: "E-posta",
        filterWorkPlan: "Çalışma Grubu",
        filterTitle: "Ünvanı",
        filterState: "Durumu",
        filterStatus: "Statü",
        filterAccessGroup: "Geçiş Grubu",
        filterFoodGroup: "Yemek Grubu",
        filterDepartments: "Departmanlar",
        filterAllowence: "İzinler",
        filterDepartmentNotRecord: "Departman kaydı bulunamadı.",
        filterDeleted: "Silinenler",
        filterNotShow: "Gösterme",
        filterVisitorCards: "Ziyaretçi Kartları",
        filterShow: "Göster",
        filterSelectExtraFields: "Özel Alan Seçiniz",
        filterCancel: "İptal",
        filterClear: "Sıfırla",
        filterApply: "Filtrele",
        filterValue: "Değer",
        filterComplete: "Seçimi Tamamla",
        filterPlateNo: "Plaka veya Etiket No",
        searchEmployeeFromList: "Liste içinde kişi arayın...",
        employeeList: "Kişi Listesi",
        employeeNotRecord: "Kişi kaydı bulunamadı.",
      },
      alerts: {
        fileSizeIsTooHigh: "Dosya boyutu çok yüksek...",
        pleaseCheckTheFileFormat: "Lütfen dosya formatını kontrol edin",
        pleaseSelectFile: "Lütfen dosya seçin...",
        pleaseSelectADocumentDefinition: "Lütfen belge tipi seçin",
        fileUploadSuccessfull: "Dosya başarıyla yüklendi!",
        departmentAndMainDepartmentOverlap: "Departman ve ana departman aynı olamaz...",
        wrongEmail: "Lütfen geçerli bir e-posta adresi girin",
        wrongEmailOrUsername: "Lütfen geçerli bir e-posta adresi veya kullanıcı adı girin",
        wrongPassword: "Lütfen parolanızı kontrol edin",
        undefinedUser: "Tanımsız kullanıcı",
        userNotFound: "Kullanıcı bulunamadı",
        salaryNameNotBlank: "Ödeme & kesinti adı boş bırakılamaz...",
        savedSuccessfully: "Başarıyla kaydedildi!",
        updatedSuccessfully: "Başarıyla güncellendi",
        deletedSuccessfully: "Başarıyla silindi!",
        visitorCardGroupNameNotBlank: "Kart grubu adı boş bırakılamaz...",
        statusNameNotBlank: "Statü adı boş bırakılamaz...",
        stateNameNotBlank: "Durum adı boş bırakılamaz...",
        selectedDayNotMissingHour: "Seçilen güne ait eksik saat yok",
        notSelectedReader: "Lütfen bir okuyucu seçin...",
        cannotCreateMovementInTheFuture: "İleri tarihte bir hareket oluşturamazsınız...",
        getReadersError: "Okuyucular çekilirken hata oluştu...",
        creditNotBlank: "Lütfen kredi girin...",
        commandSendToReaderSuccessfully: "Okuyucuya yetki komutu başarıyla gönderildi!",
        commandSentToDevicesSuccessfully: "Terminallere yetki komutları başarıyla gönderildi!",
        getUserInfoFromTerminalsSuccessfully: "Terminallerden kişi bilgileri başarıyla istendi!",
        getFaceTemplateFromSuccessfully: "Terminallerden kişiye ait yüz izi bilgisi başarıyla istendi!",
        getFingerprintFromUsbReader: "Parmak izi alma komutu başarıyla gönderildi!",
        getFingerprintsFromTerminalsSuccessfully: "Terminallerden kişiye ait parmak izi bilgileri başarıyla istendi!",
        confirmedOvertimeCannotBeGreaterThanCalculated: "Onaylanan fazla mesai, hesaplanandan daha büyük olamaz...",
        selectedEmployeeNotBlank: "Lütfen önce kişi seçin...",
        selectedReportNotBlank: "Lütfen önce rapor seçin...",
        invalidDate: "Lütfen geçerli bir tarih girin...",
        invalidPrice: "Lütfen tutarı kontrol edin...",
        invalidSalaryType: "Lütfen ödeme & kesinti tipi seçin...",
        employeeRegistrationNumberNotBlank: "Sicil no alanı boş bırakılamaz...",
        employeeNameNotBlank: "Ad soyad alanı boş bırakılamaz...",
        employeeDepartmentNotBlank: "Departman alanı boş bırakılamaz...",
        employeeDeviceNoNotBlank: "Terminal no alanı boş bırakılamaz...",
        employeeStartDateNotBlank: "Giriş tarihi boş bırakılamaz...",
        employeeTitleNotBlank: "Ünvan alanı boş bırakılamaz...",
        employeeIdentityNoNotBlank: "Vatandaşlık numarası boş geçilemez...",
        employeeEndDateNotBlank: "Çıkış tarihi boş bırakılamaz...",
        employeeWorkGroupIdNotBlank: "Çalışma grubu alanı boş bırakılamaz...",
        employeeStateIdNotBlank: "Durum alanı boş bırakılamaz...",
        employeeStateNoteNotBlank: "Durum notu alanı boş bırakılamaz...",
        employeeStatuIdNotBlank: "Statü alanı boş bırakılamaz...",
        employeeCardNoNotBlank: "Kart numarası alanı boş bırakılamaz...",
        employeeTerminalStatuNotBlank: "Terminal statü alanı boş bırakılamaz...",
        employeeTerminalPasswordNotBlank: "Terminal parolası alanı boş bırakılamaz...",
        employeeTzCodeNotBlank: "Geçiş parametreleri alanı boş bırakılamaz...",
        employeePlateNoNotBlank: "Plaka alanı boş bırakılamaz...",
        employeeHgsNoNotBlank: "HGS alanı boş bırakılamaz...",
        employeeDocumentNoNotBlank: "Belge numarası alanı boş bırakılamaz...",

        visitorCardRegistrationNumberNotBlank: "Sicil no alanı boş bırakılamaz...",
        visitorCardNameNotBlank: "Kart adı alanı boş bırakılamaz...",
        visitorCardDeviceNoNotBlank: "Terminal no alanı boş bırakılamaz...",
        visitorCardCreateDateNotBlank: "Kayıt tarihi boş bırakılamaz...",
        userIsNotAuthorizedToSeeData: "Kullanıcınızın veri görmeye yetkisi yok",
        payrollOfTheEmployeeWasRecalculated: "Kişiye ait puantaj yeniden hesaplandı",
        confirmedOvertimeDeleted: "Onaylanan fazla mesai silindi",
        youAreOnlyAuthorizedToViewThisPage: "Bu sayfayı sadece görüntüleyebilme yetkisine sahipsiniz...",
        attentionPersonIsInBlackList: "Dikkat! Kişi kara listede!",
        cardIsUsed: "Kart kullanımda!",
        unableToConnectPageRefreshing: "Bağlantı sağlanamadı... Sayfa yenileniyor...",
        attentionPersonIsInBlackListNotBeenUpdated: "Dikkat! Kişi güncellenemedi. Çünkü kara listede!",
        visitorSuccessfullyExit: "Başarıyla çıkış yapıldı.",
        visitorIdentityNumberNotBlank: "Vatandaşlık numarası boş geçilemez...",
        visitorNameNotBlank: "Ziyaretçi adı boş geçilemez...",
        payrollOfTheEmployeesWasRecalculated: "Kişilere ait puantaj yeniden hesaplandı",
        allowenceNotSelected: "Lütfen izin seçin...",
        checkConfirmedTimes: "Hesaplanan süreden fazla onaylanmış kayıtlar var. Lütfen onaylanan süreleri kontrol edin...",
        confirmationOvertimeSuccessfully: "Fazla mesai onaylama başarıyla tamamlandı!",
        selectedRecordNotFound: "Seçilen kayıt bulunamadı",
        recordNotFound: "Kayıt bulunamadı.",
        checkTheMealTime: "Girilen saatte tanımlı öğün bulunmamaktadır. Lütfen yemek saatini kontrol edin...",
        mealNameNotBlank: "Öğün adı boş bırakılamaz",
        selectedMealNotBlank: "Lütfen öğün seçimi yapın",
        invalidTimeRange: "Lütfen saat aralığını kontrol edin",
        foodGroupNameNotBlank: "Grup adı boş bırakılamaz",
        selectedDepartmentNotBlank: "Lütfen departman seçimi yapın",
        selectedAccessGroupNotBlank: "Lütfen geçiş grubu seçimi yapın",
        accessGroupNameNotBlank: "Geçiş grubu adı boş bırakılamaz",
        pleaseCheckTimes: "Lütfen girilen saatleri kontrol edin",
        pleaseSelect: "Lütfen bir seçim yapın",
        pleaseEnterPeriodStartDate: "Lütfen periyod başlangıç tarihi girin",
        pleaseEnterShortCodeAndName: "Lütfen kısa kod ve isim girin",
        pleaseEnterAName: "Lütfen bir isim girin",
        pleaseEnterAEmail: "Lütfen bir e-posta girin",
        pleaseCheckEnteredValue: "Lütfen girilen değerleri kontrol edin",
        pleaseEnterADeviceNo: "Lütfen terminal numarası girin",
        pleaseEnterADeviceName: "Lütfen terminal adı girin",
        pleaseEnterIpAddressAndPort: "Lütfen Ip adresi ve port girin",
        pleaseEnterAReaderName: "Lütfen okuyucu adı girin",
        pleaseReaderNoOrPressButtonNewReader: "Lütfen okuyucu numarası girin veya yeni okuyucu butonuna basın",
        pleaseSelectReader: "Lütfen okuyucu seçin",
        pleaseCheckFoodGroupAndDate: "Lütfen yemek grubunun seçili olduğundan ve tarihin doğru olduğundan emin olun...",
        insufficientBalance: "Yetersiz bakiye!",
        pleaseEnterAmount: "Lütfen bir tutar girin...",
        noContactInformation: "Kişi bilgisi mevcut değil...",
        pleaseEnterADate: "Lütfen tarih girin",
        pleaseEnterACompanyName: "Lütfen şirket adı girin...",
        pleaseEnterAUserName: "Lütfen kullanıcı adı girin...",
        pleaseEnterAPassword: "Lütfen parola girin...",
        passwordsDoNotMatch: "Parolalar eşleşmedi...",
        pleaseSelectAuthorityGroup: "Lütfen yetki grubu seçin...",
        pleaseCheckEmptyFields: "Lütfen boş alanları kontrol edin",
        transfersTriggeredSuccessfully: "Aktarımlar başarıyla tetiklendi!",
        pleaseSelectFile: "Lütfen dosya seçin...",
        transactionSuccessfull: "İşlem başarılı!",
        youAreNotAuthorizedForThisAction: "Bu işlem için yetkiniz yok..."
      },
      errors: {
        connectionError: "Bağlantı Hatası : servise ulaşılamadı"
      },
      loginPage: {
        select: "Seçiniz",
        welcome: 'Giriş yapmak için kullanıcı bilgilerinizi girin.',
        fullScreenInfo: "Tam ekran kullanım için 'F11' tuşuna basın.",
        loginButton: "Giriş Yap",
        emailOrUsername: "E-posta adresi veya kullanıcı adı",
        password: "Şifre",
        title1: "Modern Arayüz",
        title2: "Esnek Platform",
        title3: "Kolay Kullanım",
        title4: "Hızlı Çözüm",
        infoTitle1: "Modern Arayüz",
        infoContent1: "Mobil uyumlu arayüz ile dilediğiniz yerden sınırsız erişim",
        infoTitle2: "Bağımsız Platform",
        infoContent2: "Windows, Linux, Mac, Pardus vb. işletim sistemleri desteği",
        infoTitle3: "Esnek Veritabanı",
        infoContent3: "MSSQL, PostgreSQL vb. ilişkisel tüm veritabanı çeşitleri ile çalışma",
        infoTitle4: "Sınırsız Kullanıcı",
        infoContent4: "Sınırsız kullanıcı ve kolaylaştırılmış arayüz",
        infoTitle5: "Sınırsız Alt Kırılım",
        infoContent5: "Sınırsız ve esnek alt yapı ile özel filtreleme",
        infoTitle6: "Esnek Çalışma Tipleri",
        infoContent6: "Her sektöre uygun çalışma tipi desteği",
        infoTitle7: "Ayrıntılı Raporlar",
        infoContent7: "Esnek rapor çeşitleri ve tek tıkla dışa aktarım",
        infoTitle8: "Otomatik Mail",
        infoContent8: "İstenilen kişilere otomatik rapor gönderimi",
        infoTitle9: "Canlı İzleme",
        infoContent9: "Geçişleri gerçek zamanlı görüntüleme",
        infoTitle10: "Dil Seçenekleri",
        infoContent10: "Her kullanıcı için özelleştirilebilir dil seçenekleri",
        infoTitle11: "Esnek Altyapı",
        infoContent11: "Geliştirme ve entegrasyonlara açık altyapı",
        infoTitle12: "Sınırsız Güncelleme",
        infoContent12: "Hızlı destek ve sınırsız güncelleme hizmeti",
      },
      dashboard: {
        startOfWorks: "İŞ BAŞI YAPANLAR",
        absentees: "GELMEYENLER",
        totalEmployee: "TOPLAM KİŞİ",
        lateComers: "GEÇ GELENLER",
        lastUpdate: "SON GÜNCELLEME",
        deviceStatus: "Terminal Durumları",
        device: "Terminal",
        lastConnection: "Son Bağlantı",
        status: "Durumu",
        deviceNotFound: "Terminal kaydı bulunamadı.",
        allowenceRequests: "İzin Talepleri",
        allowenceRequest: "İzin Talebi",
        allowenceRequestNotFound: "Bekleyen izin talebi bulunmuyor.",
        allowenceHeadNameAndDescription: "Kişi / Açıklama",
        allowenceHeadRequestedDates: "Talep Edilen Tarihler",
        viewDetails: "Detayları Görüntüle",
        upcomingBirthdays: "Yaklaşan Doğum Günleri",
        upcomingBirthdaysNotFound: "Yaklaşan doğum günü bulunmuyor.",
        insides: "İçeridekiler",
        outsides: "Dışarıdakiler",
        allowenceEmployees: "İzinliler",
        insideVisitors: "İçerideki Ziyaretçiler",
        totalCar: "Toplam Araç",
        insideCar: "İçerideki Araçlar",
        outsideCar: "Dışarıdaki Araçlar",
        registeredMobileAppUser: "Kayıtlı Mobil Kullanıcı",
        activeMobileAppUser: "Aktif Mobil Kullanıcı",
        activeStudentsInDormitory: "Toplam Aktif Öğrenci",
        insideStudentsInDormitory: "İçerideki Öğrenciler",
        outsideStudentsInDormitory: "Dışarıdaki Öğrenciler",
        allowencedStudentsInDormitory: "İzinli Öğrenciler",
        fastReportView: "Hızlı Raporda Görüntüle",
        fastReportTitleTodayStartOfWorks: "Bugün İş Başı Yapanlar",
        fastReportTitleTodayAbsentees: "Bugün Gelmeyenler",
        fastReportTitleTotalEmployees: "Toplam Kişiler",
        fastReportTitleTodayLateComers: "Bugün Geç Gelenler",
        fastReportTitleInsides: "İçerideki Kişiler",
        fastReportTitleOutsides: "Dışarıdaki Kişiler",
        fastReportTitleTodayAllowence: "Bugün İzinli Kişiler",
        fastReportTitleInsideVisitors: "İçerideki Ziyaretçiler",
        fastReportTitleTotalCars: "Toplam Araçlar",
        fastReportTitleInsideCars: "İçerideki Araçlar",
        fastReportTitleOutsideCars: "Dışarıdaki Araçlar",
        fastReportTitleActiveStudents: "Yurda Kayıtlı Aktif Öğrenciler",
        fastReportTitleInsideStudents: "Yurdun İçinde Bulunan Öğrenciler",
        fastReportTitleOutsideStudents: "Yurdun Dışında Bulunan Öğrenciler",
        fastReportTitleAllowencedStudents: "Yurda Kayıtlı İzinli Öğrenciler",
        fastReportTitleMobileAppUsers: "Mobil Uygulama Kullanıcıları",
        fastReportTitleActiveMobileAppUsers: "Aktif Mobil Uygulama Kullanıcıları",
        fastReportNotRecord: "Görüntülenecek sonuç bulunamadı.",
        fastReportHeaderItems: {
          registrationNumber: "Sicil No",
          name: "Ad Soyad",
          department: "Departman",
          datetime: "Zaman",
          status: "Statü",
          citizenshipNumber: "Vatandaşlık No",
          visitorName: "Ziyaretçi Adı",
          entryTime: "Giriş Zamanı",
          title: "Ünvan",
          mobilePhone: "Telefon",
          device: "Cihaz Modeli",
          readerName: "Okuyucu Adı"
        }
      },
      realTimeMonitor: {
        inputStatus: "Kapı Durumları",
        openDoor: "Tetik Gönder",
        relayDelay: "Tetik Süresi (sn)",
        pleaseEnterRelayDelay: "Lütfen tetik süresini saniye cinsinden girin...",
        openDoorCommandSentSuccessfully: "Kapı açma komutu başarıyla gönderildi!",
        foodMenuAndView: "Yemekhane Menüsü ve İzleme",
        entryExitList: "Geçiş Listesi",
        lastEntry: "Son Yapılan Giriş",
        lastExit: "Son Yapılan Çıkış",
        logNotFoundInfo: "Geçiş hareketi olduğunda bu alanda listelenecektir.",
        foodMenu: "Yemek Menüsü",
        todayTotalFood: "Bugün Yenilen Yemek Toplamı",
        entryOrExitLogInfo: "Geçiş Bilgisi",
        logTime: "Geçiş Zamanı",
        logDescription: "Geçiş Açıklaması",
        mealPay: "Yemek Ücreti",
        availableBalance: "Kalan Bakiye",
        movementLogDescription: {
          moveIn: "Geçiş yaptı",
          entryIn: "Giriş yaptı",
          exitOut: "Çıkış yaptı",
          unregisteredCard: "Tanımsız Kart",
          noAccess: "Onay yok",
          dailyMealRightExpired: "Günlük yemek hakkı doldu",
          mealClaimExpired: "Öğün hakkı doldu",
          insufficientBalance: "Yetersiz bakiye",
          foodGroupNotSelected: "Yemek grubu seçilmemiş",
          timeLimit: "Zaman sınırı",
          antipassback: "Antipassback ihlali"
        }
      },
      employees: {
        searchEmployeeInList: "Liste içinde kişi arayın",
        employeeList: "Kişi Listesi",
        employeeSearchNotFound: "Kişi kaydı bulunamadı.",
        employeeInfo: "Kişi Bilgileri",
        newEmployee: "Yeni Kişi",
        updateEmployee: "Kişiyi Güncelle",
        saveEmployee: "Kişiyi Kaydet",
        deleteEmployee: "Kişiyi Sil",
        selectedDepartment: "Seçilen Departman",
        removePhoto: "Kaldır",
        selectPhoto: "Fotoğraf Seç",
        deletedRecord: "Silinmiş Kayıt",
        recordType: "Kayıt Tipi",
        employee: "Personel",
        student: "Öğrenci",
        doesStayInTheDormitory: "Yurtta kalıyor",
        doesNotStayInTheDormitory: "Yurtta kalmıyor",
        foodClaim: "Yemek Hakkı",
        registrationNumber: "Sicil No",
        dateOfStartWork: "Başlama Tarihi",
        dateOfStart: "Kayıt Tarihi",
        dateOfEnd: "Çıkış Tarihi",
        dateOfEndWork: "Çıkış Tarihi",
        roomInformation: "Oda - Daire Bilgisi",
        validityStartDate: "Geçerlilik Başlangıç Tarihi",
        validityEndDate: "Geçerlilik Bitiş Tarihi",
        createValidityDate: "Geçerlilik Tarihi Oluştur",
        removeValidityDate: "Geçerlilik Tarihini Kaldır",
        isContinueRemoveValidityDate: "Geçerlilik tarihi kaldırılacaktır. Devam edilsin mi?",
        createValidityDateDescription: "Oluşturmak istediğiniz geçerlilik tarihini girin...",
        passwordExist: "Şifre kaydı mevcut",
        passwordNotExist: "Şifre kaydı mevcut değil",
        cardNumberExist: "Kart numarası var",
        cardNumberNotExist: "Kart numarası mevcut değil",
        fingerprintExist: "Parmak izi kaydı var",
        fingerprintNotExist: "Parmak izi kaydı mevcut değil",
        faceTemplateExist: "Yüz izi kaydı var",
        faceTemplateNotExist: "Yüz izi kaydı mevcut değil",
        fingerPrintInformation: "Parmak İzi Bilgileri",
        fingerPrintDescription: "Lütfen parmak izi almak veya silmek için bir seçim yapın.",
        isVisitorCard: "Ziyaretçi Kartı",
        visitorCardGroup: "Ziyaretçi Kart Grubu",
        visitorCardGroups: "Ziyaretçi Kart Grupları",
        cardGroupList: "Kart Grup Listesi",
        newCardGroup: "Yeni Kart Grubu",
        visitorCardGroupNotFound: "Ziyaretçi kart grubu kaydı bulunamadı.",
        cardGroupName: "Kart Grubu Adı",
        readerNotFound: "Okuyucu kaydı bulunamadı.",
        setLeaveDate: "Çıkış Bildir",
        backToWork: "Kaydı Geri Al",
        reActivate: "Yeniden Aktif Et",
        generalInformation: "Genel Bilgiler",
        studentInformation: "Öğrenci Bilgileri",
        extraFields: "Özel Alanlar",
        mobileApp: "Mobil Geçiş",
        otherInformation: "Diğer Bilgileri",
        accessAuthorities: "Yetkiler",
        movements: "Hareketler",
        allowences: "İzinler",
        payroll: "Puantaj",
        annualPermit: "Yıllık İzin",
        payments: "Ödemeler",
        foodGroup: "Yemek Grubu",
        employeeLogs: "İşlem Geçmişi",
        cardPrinting: "Kart Baskı",
        selectTemplate: "Şablon Seçin",
        registrationNumberInfo: "Sicil No",
        citizenshipNumber: "Vatandaşlık No",
        nameSurname: "Ad Soyad",
        department: "Departman",
        title: "Ünvan",
        dateofBirth: "Doğum Tarihi",
        dateOfStartWorkInfo: "Başlama Tarihi",
        status: "Statü",
        state: "Durum",
        stateNote: "Durum Notu",
        deviceEmployeeNumber: "Terminal Numarası",
        deviceStatus: "Terminal Statü",
        deviceCardNo: "Kart Numarası",
        devicePassword: "Terminal Şifre",
        plateNo: "Araç Plaka No",
        hgsNo: "Araç Etiket No",
        workPlan: "Çalışma Grubu",
        documentNo: "Belge No",
        salary: "Maaş",
        overtimeStatus: "Fazla Mesai Durumu",
        takesOvertime: "Fazla Mesai Alır",
        motherName: "Anne Adı",
        motherPhone: "Anne Cep Telefon",
        fatherName: "Baba Adı",
        fatherPhone: "Baba Cep Telefon",
        activateSmsSystem: "SMS Gönderimi",
        smsSendPhone: "SMS Gönderilecek Telefon",
        createExtraField: "Yeni Oluştur",
        extraFieldNoteInfo: "Not : Açılan gruplama alanları tüm kişiler için geçerli olacaktır.",
        keyExtraField: "Adı",
        valueExtraField: "Değeri",
        saveExtraField: "Kaydet",
        extraFieldNotRecord: "Özel alan kaydı bulunamadı.",
        email: "E-posta",
        address: "Adres",
        mobileNumber: "Cep Tel",
        internal: "Dahili",
        mobileBrand: "Cihaz Modeli",
        notPaired: "Eşleştirilmemiş",
        resetPairing: "Eşleştirmeyi Sıfırla",
        unknown: "Bilinmeyen Cihaz",
        isMobileAppUser: "Mobil Uygulama Kullanıcısı Mı?",
        mobileAppPassword: "Mobil Uygulama Parolası",
        qrReaderMode: "QR Okuyucu Modu",
        qrReaderModeAll: "Tümü",
        qrReaderModeOnlyQRCreate: "QR Üreterek",
        qrReaderModeOnlyQRRead: "QR Okuyarak",
        qrReaderModeOnlyWithButton: "Buton ile",
        qrReaderModeQRCreateAndRead: "QR Üreterek & QR Okuyarak",
        qrReaderModeQRReadAndButton: "QR Okuyarak & Buton ile",
        qrReaderModeQRCreateAndButton: "QR Üreterek & Buton ile",
        homePhone: "Ev Tel",
        gender: "Cinsiyet",
        male: "Erkek",
        female: "Kadın",
        educationStatus: "Eğitim Durumu",
        primarySchool: "İlk Öğretim",
        highSchool: "Orta Öğretim",
        associateDegree: "Ön Lisans",
        bachelorDegree: "Lisans",
        postGraduate: "Yüksek Lisans",
        doctorate: "Doktora",
        militaryStatus: "Askerlik Durumu",
        done: "Yapıldı",
        exempt: "Muaf",
        smokingStatus: "Sigara Durumu",
        smoking: "Kullanıyor",
        notSmoking: "Kullanmıyor",
        maritalStatus: "Medeni Durumu",
        single: "Bekar",
        married: "Evli",
        widow: "Dul",
        drivingLicence: "Ehliyet",
        foreignLanguage: "Yabancı Dil",
        bloodType: "Kan Grubu",
        height: "Boy",
        weight: "Kilo",
        disabledPercent: "Engellilik Yüzdesi",
        authorizedPerson1: "1. Sorumlu Kişi",
        authorizedPerson2: "2. Sorumlu Kişi",
        note1: "Not-1",
        note2: "Not-2",
        accessAuthoritiesInfo: "Geçiş Grubu",
        sendPersontoDevices: "Kişiyi Yetkili Terminallere Gönder",
        deviceList: "Terminal Listesi",
        sendToReader: "Okuyucuya Gönder",
        getFingerprint: "Parmak izi al",
        getFaceTemplate: "Yüz izi al",
        getUserData: "Kişiye ait verileri çek",
        deviceNotRecord: "Terminal kaydı bulunamadı.",
        newMovement: "Yeni Hareket",
        allDoors: "Tüm Kapılar",
        pdks: "PDKS",
        access: "Access",
        diningHall: "Yemekhane",
        licencePlateRecognition: "Plaka Tanıma",
        dormitoryDevice: "Yurt Terminali",
        all: "Tümü",
        active: "Aktif",
        passive: "Pasif",
        startDateMovements: "Başlangıç",
        endDateMovements: "Bitiş",
        searchMovements: "Listele",
        location: "Konum",
        timeMovement: "Zaman",
        deviceMovement: "Geçiş Noktası",
        statusMovement: "Geçiş",
        manuelMovement: "Manuel Hareket",
        entryMovement: "Giriş",
        exitMovement: "Çıkış",
        movementNotRecord: "Hareket kaydı bulunamadı.",
        addMovement: "Hareket Ekle",
        editMovement: "Hareket Düzenle",
        typeMovement: "Hareket Tipi",
        readerMovement: "Okuyucu",
        includePassivesMovement: "Pasif olan hareketleri de dahil et",
        confirmedOvertimeNotDeleted: "Onaylanan fazla mesailer silinmesin",
        newAllowence: "Yeni İzin",
        removeAllowence: "İzin Sil",
        removeAllowenceInSelectedDates: "Seçilen Tarih Aralığındaki İzinleri Sil",
        startDateAllowences: "Başlangıç",
        endDateAllowences: "Bitiş",
        searchAllowences: "Listele",
        startAllowence: "Başlangıç",
        endAllowence: "Bitiş",
        codeAllowence: "Kodu",
        nameAllowence: "İzin Adı",
        allowenceNotRecord: "İzin kaydı bulunamadı.",
        addAllowence: "İzin Ekle",
        editAllowence: "İzin Düzenle",
        validDays: "Geçerli Günler",
        typeAllowence: "İzin Tipi",
        dailyAllowence: "Günlük İzin",
        hourlyAllowence: "Saatlik İzin",
        startTimeAllowence: "Başlangıç Zamanı",
        endTimeAllowence: "Bitiş Zamanı",
        allowence: "İzin",
        totalTimeAllowence: "Toplam Zaman",
        missingHourAllowence: "Eksik Saat",
        isEqualTheMissingTime: "Eksik saat süresiyle eşitlensin mi?",
        equalTheMissingTime: "Eksik saat süresiyle eşitle",
        doesApplyHolidays: "Tatil günleri içinde geçerli olsun mu?",
        applyHolidays: "Tatil günleri içinde geçerli olsun",
        descriptionAllowence: "Açıklama",
        recalculate: "Yeniden Hesapla",
        startDatePayrolls: "Başlangıç",
        endDatePayrolls: "Bitiş",
        searchPayrolls: "Listele",
        payrollNotRecord: "Puantaj kaydı bulunamadı.",
        datePayroll: "Tarih",
        workPlanPayroll: "Çalışma Planı",
        firstEntry: "İlk Giriş",
        lastExit: "Son Çıkış",
        calculatedOvertime: "Hesap. F.M.",
        confirmedOvertime: "Onaylanan F.M.",
        confirmTheCalculated: "Hesaplananı onayla",
        deleteTheConfirmed: "Onaylananı sil",
        annualPermitGroups: "Yıllık İzin Grubu",
        seniority: "Kıdem",
        transfer: "Devir",
        remaining: "Kalan",
        deservedAnnualPermits: "Hakedilen Yıllık İzinler",
        deservedDate: "Hakediş Tarihi",
        deservedDay: "Hakedilen Gün",
        annualPermitNotRecord: "Hakedilen yıllık izin kaydı bulunamadı.",
        usedAnnualPermits: "Kullanılan Yıllık İzinler",
        annualPermitDate: "İzin Tarihi",
        annualPermitName: "İzin Adı",
        annualPermitDescription: "Açıklama",
        usedAnnualPermitNotRecord: "Kullanılan yıllık izin kaydı bulunamadı.",
        payments: "Ödemeler",
        paymentDefinitions: "Ödeme Tanımları",
        newPayment: "Yeni",
        startDatePayments: "Başlangıç",
        endDatePayments: "Bitiş",
        searchPayments: "Listele",
        timePayment: "Zaman",
        namePayment: "Ödeme & Kesinti Adı",
        amountPayment: "Tutar",
        statusPayment: "Durum",
        addedSalary: "Maaşa Eklenir",
        decreaseFromSalary: "Maaştan Düşer",
        paymentNotRecord: "Ödeme & kesinti kaydı bulunamadı.",
        addPayment: "Ödeme & Kesinti Ekle",
        editPayment: "Ödeme & Kesinti Düzenle",
        typePayment: "Ödeme & Kesinti Tipi",
        effectOnSalary: "Maaşa Etkisi",
        remainingCredits: "Kalan Kontör",
        availableBalance: "Kalan Bakiye",
        addCredit: "Kontör Yükle",
        addBalance: "Bakiye Yükle",
        amountOfCredit: "Kontör Miktarı",
        amountOfBalance: "Bakiye Miktarı",
        startDateLogs: "Başlangıç",
        endDateLogs: "Bitiş",
        searchLogs: "Listele",
        timeLog: "İşlem Zamanı",
        descriptionLog: "İşlem Açıklaması",
        logNotRecord: "İşlem kaydı bulunamadı.",
        selectEmployee: "Kişi Seç",
        searchFromNameSurname: "Ad soyada göre arayın.",
        isContinueUpdateEmployee: "Seçilen kişi güncellenecektir. Devam edilsin mi?",
        isContinueSaveEmployee: "Yeni kişi kaydedilecektir. Devam edilsin mi?",
        isContinueDeleteEmployee: "Seçilen kişi silinecektir. Devam edilsin mi?",
        setLeaveDateInfo: "Seçilen kişi için çıkış bildirimi yapılacaktır. Lütfen çıkartmak istediğiniz tarihi girin.",
        updateWorkPlan: "Çalışma Planı Güncelle",
        updateAllowence: "İzin Güncelle",
        updateAllowenceNotRecord: "Kayıt bulunamadı.",
        updateWorkPlanNotRecord: "Kayıt bulunamadı.",
        states: "Durumlar",
        stateList: "Durum Listesi",
        newState: "Yeni Durum",
        stateNotRecord: "Durum kaydı bulunamadı.",
        stateName: "Durum Adı",
        enableToLeaveDate: "Seçildiğinde ayrılma tarihi etkinleşsin",
        statusTitle: "Statüler",
        statusList: "Statü Listesi",
        newStatus: "Yeni Statü",
        statusNotRecord: "Statü kaydı bulunamadı.",
        statusName: "Statü Adı",
        selectDepartment: "Departman Seçin",
        departmentNotRecord: "Departman kaydı bulunamadı.",
        confirmSelectedOvertime: "Fazla Mesaiyi Onayla",
        overtimePlace: "Fazla Mesai Yeri",
        overtimeDescription: "Fazla Mesai Nedeni",
        dailyPayrollDetail: "Günlük Puantaj Detayı",
        payrollDetail: "Puantaj Detayı",
        movementsOT: "Hareketler",
        payrollTime: "Süre",
        movementOT: "Hareket",
        statusOT: "Durum",
        calculatedOvertimeLong: "Hesaplanan F.M.",
        confirmedOvertimeLong: "Onaylanan F.M.",
        workPlaceStartDate: "Başlangıç",
        workPlaceEndDate: "Bitiş",
        workPlace: "Görev Yeri",
        workPlaces: "Görev Yerleri",
        workPlaceDefinitions: "Görev Yeri Tanımları",
        newWorkPlace: "Yeni Görev Yeri",
        workPlaceDescription: "Görev Yeri Açıklaması",
        addWorkplace: "Görev Yeri Ekle",
        editWorkplace: "Görev Yeri Düzenle",
        descriptionWorkPlace: "Görev Yeri Açıklaması",
        salary: "Maaş",
        updateTime: "Güncelleme Zamanı",
        addSalary: "Maaş Ekle",
        editSalary: "Maaş Düzenle",
        newSalary: "Yeni Maaş",
        assignedInventory: "Zimmetler",
        
        inventoryName: "Adı",
        inventoryQuantity: "Adet",
        inventoryDescription: "Açıklama",
        deliveryDate: "Verildiği Tarih",
        takenDate: "Teslim Alındığı Tarih",
        addInventory: "Zimmet Ekle",
        selectedInventory: "Demirbaş",
        documents: "Belgeler",
        addDocument: "Belge Ekle",
        documentDescription: "Açıklama",
        documentType: "Belge Tipi",
        editDocument: "Döküman Bilgilerini Düzenle",
        documentFile: "Dosya",
        isgDocument: "İSG Belgesi",
        validityStartDate: "Geçerlilik Başlangıç Tarihi",
        validityEndDate: "Geçerlilik Bitiş Tarihi",
        isgDocumentValidity: "İSG belgelerinde geçerlilik başlangıç ve bitiş tarihleri boş geçilemez"
      },
      visitors: {
        waitingVisitors: "Beklenenler",
        blackList: "Kara Liste",
        reasonsForVisit: "Ziyaret Nedenleri",
        visitorName: "Ziyaretçi Adı",
        reasonForVisit: "Ziyaret Nedeni",
        appointmentTime: "Randevu Zamanı",
        waitingVisitorNotRecord: "Beklenen ziyaretçi kaydı bulunamadı.",
        citizenshipNumber: "Vatandaşlık No",
        blackListName: "Kişi Adı",
        blackListDescription: "Açıklama",
        blackListNotRecord: "Kara liste kaydı bulunamadı.",
        reasonForVisitNotRecord: "Ziyaret nedeni kaydı bulunamadı.",
        inUse: "Kullanımda",
        ready: "Hazır",
        givenTemporary: "Geçici Verildi",
        visitorCardNotRecord: "Ziyaretçi kartı kaydı bulunamadı.",
        employeeStatus: "Kişi Durumları",
        searchEmployeeFromList: "Listeden kişi arayın...",
        searchVisitorCardFromList: "Listeden ziyaretçi kartı arayın...",
        employeeNotRecord: "Kişi kaydı bulunamadı.",
        in: "İçeride",
        out: "Dışarıda",
        noLatestStatusInformation: "Son durum bilgisi yok",
        visitorInformation: "Ziyaretçi Bilgileri",
        previousSimilarRecords: "Önceki Benzer Kayıtlar",
        similarRecordNotFound: "Benzer kayıt bulunamadı.",
        employeeList: "Kişi Listesi",
        visitorCard: "Ziyaretçi kartı",
        temporaryCardForEmployee: "Çalışan için geçici kart",
        nameSurname: "Adı Soyadı",
        mobilePhone: "Cep Telefonu",
        where: "Nereye",
        person: "Kişi",
        company: "Kurum",
        other: "Diğer",
        description: "Açıklama",
        visitedEmployeeInformation: "Ziyaret edilen kişi bilgileri",
        employeeInformation: "Kişi bilgileri",
        selectEmployee: "Kişi Seç",
        waitingVisitorInformation: "Beklenen Kişi Bilgileri",
        employeeSearch: "Kişi arayın...",
        noContactInformation: "Kişi bilgisi yok",
        visitorCards: "Ziyaretçi Kartları",
        selectVisitorCardToGive: "Verilecek ziyaretçi kartını seçin",
        readyToUseVisitorCardNotRecord: "Kullanıma uygun ziyaretçi kartı yok.",
        selectVisitorCardGroup: "Grup Seçiniz",
        isContinueDeleteReason: "Seçilen geliş nedeni kaydı silinecektir. Devam edilsin mi?",
        isContinueDeleteBlackList: "Seçilen kara liste kaydı silinecektir. Devam edilsin mi?",
        isContinueDeleteWaitingVisitor: "Seçilen beklenen kişi kaydı silinecektir. Devam edilsin mi?",

      },
      visitorCards: {
        searchVisitorCardInList: "Listeden ziyaretçi kartı arayın",
        visitorCardList: "Ziyaretçi Kartı Listesi",
        visitorCardSearchNotFound: "Ziyaretçi kartı kaydı bulunamadı.",
        visitorCardInfo: "Ziyaretçi Kartı Bilgileri",
        newVisitorCard: "Yeni Ziyaretçi Kartı",
        updateVisitorCard: "Ziyaretçi Kartını Güncelle",
        saveVisitorCard: "Ziyaretçi Kartını Kaydet",
        deleteVisitorCard: "Ziyaretçi Kartını Sil",
        removePhoto: "Kaldır",
        selectPhoto: "Fotoğraf Seç",
        deletedRecord: "Silinmiş Kayıt!",
        registrationNumber: "Sicil No",
        dateOfCreate: "Kayıt Tarihi",
        passwordExist: "Şifre kaydı mevcut",
        passwordNotExist: "Şifre kaydı mevcut değil",
        cardNumberExist: "Kart numarası var",
        cardNumberNotExist: "Kart numarası mevcut değil",
        fingerprintExist: "Parmak izi kaydı var",
        fingerprintNotExist: "Parmak izi kaydı mevcut değil",
        faceTemplateExist: "Yüz izi kaydı var",
        faceTemplateNotExist: "Yüz izi kaydı mevcut değil",
        visitorCardGroup: "Ziyaretçi Kart Grubu",
        visitorCardGroups: "Ziyaretçi Kart Grupları",
        cardGroupList: "Kart Grup Listesi",
        newCardGroup: "Yeni Kart Grubu",
        visitorCardGroupNotFound: "Ziyaretçi kart grubu kaydı bulunamadı.",
        cardGroupName: "Kart Grubu Adı",
        readerNotFound: "Okuyucu kaydı bulunamadı.",
        generalInformation: "Genel Bilgiler",
        accessAuthorities: "Yetkiler",
        movements: "Hareketler",
        employeeLogs: "İşlem Kayıtları",
        cardPrinting: "Kart Baskı",
        selectTemplate: "Şablon Seçin",
        registrationNumberInfo: "Sicil No",
        cardName: "Kart Adı",
        department: "Departman",
        dateOfCreateInfo: "Kayıt Tarihi",
        status: "Statü",
        deviceEmployeeNumber: "Terminal No",
        deviceStatus: "Terminal Statü",
        deviceCardNo: "Terminal Kart Numarası",
        devicePassword: "Terminal Şifresi",
        accessAuthoritiesInfo: "Geçiş Yetki Grubu",
        sendPersontoDevices: "Kişiyi Yetkili Terminallere Gönder",
        deviceList: "Terminal Listesi",
        selectAll: "Tümünü Seç",
        removeAll: "Tümünü Kaldır",
        sendToReader: "Okuyucuya Gönder",
        getFingerprint: "Parmak izlerini Çek",
        getFaceTemplate: "Yüz izi çek",
        getUserData: "Kişi bilgilerini çek",
        deviceNotRecord: "Terminal kaydı bulunamadı.",
        allDoors: "Tümü",
        pdks: "PDKS",
        access: "Access",
        diningHall: "Yemekhane",
        all: "Tümü",
        active: "Aktif",
        passive: "Pasif",
        startDateMovements: "Başlangıç Tarihi",
        endDateMovements: "Bitiş Tarihi",
        searchMovements: "Listele",
        timeMovement: "Zaman",
        deviceMovement: "Geçiş Noktası",
        statusMovement: "Durum",
        manuelMovement: "Manuel Hareket",
        entryMovement: "Giriş",
        exitMovement: "Çıkış",
        movementNotRecord: "Hareket kaydı bulunamadı.",
        remainingCredits: "Kalan Kontör",
        availableBalance: "Kalan Bakiye",
        addCredit: "Kontör Yükle",
        addBalance: "Bakiye Yükle",
        amountOfCredit: "Kontör Miktarı",
        amountOfBalance: "Bakiye Miktarı",
        startDateLogs: "Başlangıç",
        endDateLogs: "Bitiş",
        searchLogs: "Listele",
        timeLog: "İşlem Zamanı",
        descriptionLog: "İşlem Açıklaması",
        logNotRecord: "İşlem kaydı bulunamadı.",
        isContinueUpdateVisitorCard: "Seçilen ziyaretçi kartı güncellenecektir. Devam edilsin mi?",
        isContinueSaveVisitorCard: "Yeni ziyaretçi kartı kaydedilecektir. Devam edilsin mi?",
        isContinueDeleteVisitorCard: "Seçilen ziyaretçi kartı silinecektir. Devam edilsin mi?",
        statusTitle: "Statüler",
        statusList: "Statü Listesi",
        newStatus: "Yeni Statü",
        statusNotRecord: "Statü kaydı bulunamadı.",
        statusName: "Statü Adı",
        selectDepartment: "Departman seç",
        departmentNotRecord: "Departman kaydı bulunamadı.",
      },
      batchOperations: {
        filterTheEmployeesYouWantToSelect: "Seçmek istediğiniz kişileri filtreleyin",
        searchEmployeeFromList: "Liste içinde kişi arayın...",
        employeeList: "Kişi Listesi",
        employeeNotRecord: "Kişi kaydı bulunamadı.",
        chooseFromTheFollowingActions: "Aşağıdaki işlemlerden birini seçin",
        informationUpdate: "Bilgi Güncelle",
        informationUpdateOperations: "Bilgi Güncelleme İşlemleri",
        allowence: "İzin",
        allowenceOperations: "İzin İşlemleri",
        movement: "Hareket",
        movementOperations: "Hareket İşlemleri",
        overtime: "Fazla Mesai",
        overtimeOperations: "Fazla Mesai İşlemleri",
        payroll: "Puantaj",
        payrollOperations: "Puantaj İşlemleri",
        workPlan: "Çalışma Planı",
        workPlanOperations: "Çalışma Planı İşlemleri",
        accessGroup: "Geçiş Grubu",
        validityStartDate: "Geçerlilik Başlangıç Tarihi",
        validityEndDate: "Geçerlilik Bitiş Tarihi",
        department: "Departman",
        status: "Statü",
        state: "Durum",
        foodGroup: "Yemek Grubu",
        startDate: "Başlangıç Tarihi",
        endDate: "Bitiş Tarihi",
        startTime: "Başlangıç Zamanı",
        endTime: "Bitiş Zamanı",
        validDays: "Geçerli Günler",
        allowence: "İzin",
        allowenceType: "İzin Tipi",
        dailyAllowence: "Günlük İzin",
        hourlyAllowence: "Saatlik İzin",
        totalTimeAllowence: "Toplam Zaman",
        missingHourAllowence: "Eksik Saat",
        isEqualTheMissingTime: "Eksik saat süresiyle eşitlensin mi?",
        equalTheMissingTime: "Eksik saat süresiyle eşitle",
        doesApplyHolidays: "Tatil günleri içinde geçerli olsun mu?",
        applyHolidays: "Tatil günleri içinde geçerli olsun",
        descriptionAllowence: "Açıklama",
        movementDetails: "Hareket Detayları",
        movementTime: "Hareket Zamanı",
        reader: "Okuyucu",
        movementType: "Hareket Tipi",
        entryMovement: "Giriş",
        exitMovement: "Çıkış",
        createExitMovement: "Çıkış hareketi de oluştur",
        secondMovementTime: "2.Hareket Zamanı",
        secondMovementReader: "2.Hareket Okuyucusu",
        secondMovementType: "2.Hareket Tipi",
        confirmOvertime: "Fazla Mesai Onaylama",
        search: "Filtrele",
        overtimeWorks: "Yapılan Fazla Mesailer",
        nameSurname: "Ad Soyad",
        date: "Tarih",
        calculated: "Hesaplanan",
        confirmed: "Onaylanan",
        includePassivesMovement: "Pasif olan hareketleri de dahil et",
        confirmedOvertimeNotDeleted: "Onaylanan fazla mesailer silinmesin",
        descriptionWorkPlan: "Açıklama",
        batchInformationUpdateSuccessfully: "Toplu bilgi güncelleme başarıyla tamamlandı!",
        batchWorkPlanUpdateSuccessfully: "Toplu çalışma planı değişikliği başarıyla kaydedildi!",
        batchMovementSuccessfully: "Toplu hareket oluşturma başarıyla kaydedildi!",
        batchAllowencesSuccessfully: "Toplu izin işlemi başarıyla tamamlandı!",
        diningHall: "Yemekhane",
        diningHallOperations: "Yemekhane Toplu Bakiye Yükle",
        downloadTemplate: "Excel Şablonu İndir",
        uploadFile: "Dosya Yükle",
        uploadDescription: "Düzenlediğiniz excel şablon dosyasını yükleyin.",
      },
      reports: {
        selectReport: "Rapor Seç",
        report: "Rapor",
        noResults: "Görüntülenecek sonuç bulunamadı.",
        reportDetails: "Rapor Detayları",
        displayInReportVisitorCardGroups: "Görüntülenecek ziyaretçi kart grupları",
        visitorCardGroupNotFound: "Ziyaretçi kart grubu kaydı bulunamadı.",
        displayInReportDevices: "Görüntülenecek Terminaller",
        devicesNotFound: "Terminal kaydı bulunamadı.",
        displayInReportAllowences: "Görüntülenecek izinler",
        allowenceNotFound: "İzin kaydı bulunamadı.",
        displayInReportDepartments: "Görüntülenecek departmanlar",
        departmentNotFound: "Departman kaydı bulunamadı.",
        checkThisDevices: "Bu Cihazları İşaretle",
        reportSettings: "Rapor Ayarları",
        startDate: "Başlangıç",
        endDate: "Bitiş",
        date: "Tarih",
        reportOptions: "Rapor Seçenekleri",
        showAllowences: "İzinlileri göster",
        showMissing: "Gelmeyenleri göster",
        showLatecomer: "Geç kalanları göster",
        fromTheClock: "saatten",
        lessEmployees: "Az çalışanlar",
        moreEmployees: "Fazla çalışanlar",
        viewReport: "Raporu Görüntüle",
        selectedReportIsUnavailable: "Seçilen rapor kullanım dışı...",
        reports: {
          LaterComersReport: "Gelmeyenler Raporu",
          LaterComersReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            title: "Ünvan",
            date: "Tarih",
            status: "Durum",
            entry: "Giriş",
            difference: "Fark"
          },
          DetailedInOutReport: "Detaylı Giriş Çıkış Raporu",
          DetailedInOutReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            workPlace: "Görev Yeri",
            date: "Tarih",
            firstEntry: "İlk Giriş",
            lastExit: "Son Çıkış",
            total: "Toplam",
            status: "Durum",
            entry: "Giriş",
            exit: "Çıkış",
            difference: "Fark"
          },
          FoodReport: "Yemekhane Hareket Raporu",
          FoodReportHeader: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            title: "Ünvan",
            documentNo: "Belge No",
            departmentName: "Departman",
            readerName: "Okuyucu",
            date: "Tarih",
            debit: "Ücret"
          },
          FoodDebtReport: "Yemekhane Ücret Raporu",
          FoodDebtReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            documentNo: "Belge No",
            debit: "Borç"
          },
          FoodSummaryReport: "Yemekhane İcmal Raporu",
          FoodSummaryReportHeaders: {
            departmentName: "Departman Adı",
            total: "Toplam",
            debit: "Ücret",
          },
          EmployeesReport: "Kişi Bilgileri Raporu",
          EmployeesReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            title: "Ünvan",
            mobilePhone: "Cep Tel",
            citizenshipNumber: "Vatandaşlık No",
            status: "Statü",
            state: "Durumu",
            startDateWork: "Başlangıç Tarihi",
            leaveDate: "Çıkış Tarihi",
            validityStartDate: "Geçerlilik Başlangıç Tarihi",
            validityEndDate: "Geçerlilik Bitiş Tarihi"
          },
          InsidesReport: "İçeridekiler Raporu",
          InsidesReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            entryTime: "Giriş Zamanı",
            entryPoint: "Giriş Noktası",
            status: "Durumu"
          },
          OutsidesReport: "Dışarıdakiler Raporu",
          OutsidesReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            exitTime: "Çıkış Zamanı",
            exitPoint: "Çıkış Noktası",
            status: "Durumu"
          },
          VisitorsReport: "Ziyaretçiler Raporu",
          VisitorsReportHeaders: {
            citizenshipNumber: "Vatandaşlık No",
            nameSurname: "Ad Soyad",
            mobilePhone: "Cep Tel",
            where: "Kime",
            departmentName: "Departman",
            reasonForVisit: "Geliş Nedeni",
            visitedEmployeeInformation: "Ziyaret Edilen",
            cardIssueTime: "Kartın Verildiği Tarih",
            entryTime: "Giriş Zamanı",
            exitTime: "Çıkış Zamanı",
            cardName: "Kart Adı",
            description: "Açıklama"
          },
          InsideVisitorsReport: "İçerideki Ziyaretçiler Raporu",
          InsideVisitorsReportHeader: {
            citizenshipNumber: "Vatandaşlık No",
            nameSurname: "Ad Soyad",
            mobilePhone: "Cep Tel",
            where: "Kime",
            departmentName: "Departman",
            reasonForVisit: "Geliş Nedeni",
            visitedEmployeeInformation: "Ziyaret Edilen",
            cardIssueTime: "Kartın Verildiği Tarih",
            entryTime: "Giriş Zamanı",
            cardName: "Kart Adı",
            description: "Açıklama"
          },
          TimeBasedWorkReport: "Süre Bazlı Çalışma Raporu",
          TimeBasedWorkReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            startDate: "Başlangıç Tarihi",
            endDate: "Bitiş Tarihi",
            totalWorkedTime: "Çalışma Süresi",
            difference: "Fark"
          },
          FirstInLastOutReport: "İlk Giriş Son Çıkış Raporu",
          FirstInLastOutReportHeaders: {
            citizenshipNumber: "TC No",
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            department: "Departman",
            title: "Ünvan",
            status1: "Statü",
            workPlace: "Görev Yeri",
            workPlan: "Çalışma Grubu",
            date: "Tarih",
            firstEntry: "İlk Giriş",
            entryReader: "Giriş Okuyucu",
            lastExit: "Son Çıkış",
            exitReader: "Çıkış Okuyucu",
            status: "Durum",
            total: "Toplam Çalışma",
            missingHour: "Fark",
            earlyEntry: "Erken Gelme",
            lateEntry: "Geç Gelme",
            earlyExit: "Erken Çıkma",
            lateExit: "Geç Çıkma",
          },
          AllowenceReport: "İzinliler Raporu",
          AllowenceReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            startDate: "Başlangıç Tarihi",
            endDate: "Bitiş Tarihi",
            allowenceName: "İzin Adı"
          },
          WorkSummaryReport: "Çalışma Özeti Raporu",
          WorkSummaryReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            jobDays: "İş Günü",
            workDays: "Çalışma Günü",
            publicHoliday: "Resmi Tatil / İdari İzin",
            allowence: "İzin / Rapor",
            absentee: "Devamsızlık"
          },
          CompanyEmployeesStatusReport: "Birim Bazlı Sayı Raporu",
          CompanyEmployeesStatusReportHeaders: {
            unitName: "Birim Adı",
            employeeCount: "Personel Sayısı",
            continuedEmployeeCount: "Devam Eden Personel Sayısı",
            annualPermit: "Yıllık İzinliler",
            report: "Raporlular",
            administrativeLeave: "İdari İzinliler",
            freePermission: "Ücretsiz İzinliler",
            nonComers: "Gelmeyenler & Kart Okutmayanlar",
            missioned: "Geçici Görevlendirme",
            todayComers: "Kurumda Olanlar"
          },
          CustomCompanyEmployeesStatusReport: "Departman Bazlı Sayı Raporu",
          CustomCompanyEmployeesStatusReportHeaders: {
            unitName: "Birim Adı",
            employeeCount: "Personel Sayısı",
            continuedEmployeeCount: "Devam Eden Personel Sayısı",
            annualPermit: "Yıllık İzinliler",
            report: "Raporlular",
            administrativeLeave: "İdari İzinliler",
            freePermission: "Ücretsiz İzinliler",
            nonComers: "Gelmeyenler & Kart Okutmayanlar",
            missioned: "Geçici Görevlendirme",
            todayComers: "Kurumda Olanlar"
          },
          DepartmentSummaryReport: "İki Tarih Arası Departman Bazlı Sayı Raporu",
          DepartmentSummaryReportHeaders: {
            unitName: "Birim Adı",
            employeeCount: "Personel Sayısı",
            continuedEmployeeCount: "Devam Eden Personel Sayısı",
            annualPermit: "Yıllık İzinliler",
            report: "Raporlular",
            administrativeLeave: "İdari İzinliler",
            freePermission: "Ücretsiz İzinliler",
            nonComers: "Gelmeyenler & Kart Okutmayanlar",
            missioned: "Geçici Görevlendirme",
            todayComers: "Kurumda Olanlar"
          },
          PayrollReport: "Puantaj Raporu",
          DetailedPayrollReport: "Detaylı Puantaj Raporu",
          FoodCreditReport: "Yemekhane Yükleme Raporu",
          FoodCreditReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            date: "Tarih",
            debit: "Tutar",
            creditType: "Tipi",
            status: "Durum",
            userName: "Kullanıcı"
          },
          TemplatePayrollReport: "Puantaj Şablon-1 Raporu",
          TemplateMonthlyPayrollReport: "Aylık Puantaj Raporu",
          SalaryReport: "Maaş Raporu",
          InOutReport: "Giriş Çıkış Raporu",
          InOutReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            title: "Ünvan",
            workPlace: "Görev Yeri",
            departmentName: "Departman",
            location: "Lokasyon",
            date: "Tarih",
            readerName: "Okuyucu"
          },
          DoorBasedLastMovementReport: "Kapı Bazlı Son Hareket Raporu",
          DoorBasedLastMovementReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            title: "Ünvan",
            departmentName: "Departman",
            date: "Tarih",
            readerName: "Okuyucu",
            doorStatus: "Durum"
          },
          DoorsAuthorizationReport: "Kapı Bazlı Yetki Raporu",
          DoorsAuthorizationReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            title: "Ünvan",
            departmentName: "Departman",
            accessGroup: "Yetki Grubu"
          },
          DormitoryInformationReport: "Yurtta Kalan Öğrenciler Raporu",
          DormitoryInformationReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            departmentName: "Departman",
            isSmsSend: "SMS Gönderimi",
            motherName: "Anne Adı",
            fatherName: "Baba Adı",
            smsPhone: "SMS Tel",
            validityDate: "Geçerlilik Tarihi",
            roomName: "Oda",
            floorName: "Kat",
            areaName: "Bölge"
          },
          DormitoryInsidesReport: "Yurt İçerideki Öğrenciler Raporu",
          DormitoryInsidesReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            departmentName: "Departman",
            lastMovementDate: "Son Hareket",
            lastMovementReader: "Okuyucu",
            status: "Durumu",
            isSmsSend: "SMS Gönderimi",
            motherName: "Anne Adı",
            fatherName: "Baba Adı",
            smsPhone: "SMS Tel",
            validityDate: "Geçerlilik Tarihi",
            roomName: "Oda",
            floorName: "Kat",
            areaName: "Bölge"
          },
          DormitoryOutsidesReport: "Yurt Dışarıdaki Öğrenciler Raporu",
          DormitoryOutsidesReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            departmentName: "Departman",
            lastMovementDate: "Son Hareket",
            lastMovementReader: "Okuyucu",
            status: "Durumu",
            isSmsSend: "SMS Gönderimi",
            motherName: "Anne Adı",
            fatherName: "Baba Adı",
            smsPhone: "SMS Tel",
            validityDate: "Geçerlilik Tarihi",
            roomName: "Oda",
            floorName: "Kat",
            areaName: "Bölge"
          },
          WeeklyPayrollReport: "Haftalık Puantaj Raporu",
          WeeklyPayrollReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Adı Soyadı",
            title: "Ünvan",
            departmentName: "Departman",
            workTime: "Çalışma Süresi",
            overTime: "Fazla Mesai",
            nightWorkTime: "Gece Zammı",
            status: "Ödenecek Mesai Saati",
          },
          EntryExitSnapshotReport: "Fotoğraflı Hareket Raporu",
          EntryExitSnapshotReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Adı Soyadı",
            title: "Ünvan",
            departmentName: "Departman",
            date: "Tarih",
            reader: "Okuyucu",
            photo: "Kişi Fotoğrafı",
            snapshot: "Olay Görüntüsü"
          },
          SaleReport: "Satış Raporu",
          SaleReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Adı Soyadı",
            price: "Ücret",
            date: "Tarih",
            user: "Kullanıcı",
            isRefund: "İade Durumu"
          },
          DetailedVisitorReport: "Detaylı Ziyaretçi Hareket Raporu",
          DetailedVisitorReportHeaders: {
            citizenshipNumber: "Vatandaşlık No",
            nameSurname: "Ad Soyad",
            mobilePhone: "Cep Tel",
            where: "Kime",
            departmentName: "Departman",
            reasonForVisit: "Geliş Nedeni",
            visitedEmployeeInformation: "Ziyaret Edilen",
            cardIssueTime: "Kartın Verildiği Tarih",
            entryTime: "Giriş Zamanı",
            exitTime: "Çıkış Zamanı",
            cardName: "Kart Adı",
            description: "Açıklama"
          },
          DepartmentBasedVisitorReport: "Departman Bazlı Ziyaretçi Raporu",
          DepartmentBasedVisitorReportHeaders: {
            departmentName: "Departman",
            total: "Toplam",
          },
          ShiftReport: "Vardiya Raporu",
          ShiftReportHeaders: {
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            title: "Ünvan",
            departmentName: "Departman",
            signature: "İmza",
            isSignatureColumnAdded: "İmza Kolonu Eklensin mi?",
          },
          VerticalFirstInLastOutReport: "Dikey İlk Giriş Son Çıkış",
          VerticalFirstInLastOutReportHeaders: {
            citizenshipNumber: "Vatandaşlık No",
            registrationNumber: "Sicil No",
            nameSurname: "Ad Soyad",
            status: "Statü",
            title: "Ünvan",
            departmentName: "Departman"
          }
        }
      },
      foodGroupOperations: {
        searchEmployeeInList: "Liste içinde kişi arayın",
        employeeList: "Kişi Listesi",
        employeeSearchNotFound: "Kişi kaydı bulunamadı.",
        employeeInfo: "Kişi Bilgileri",
        deletedRecord: "Silinmiş Kayıt",
        registrationNumber: "Sicil No",
        dateOfStartWork: "Başlama Tarihi",
        dateOfEndWork: "Çıkış Tarihi",
        passwordExist: "Şifre kaydı mevcut",
        passwordNotExist: "Şifre kaydı mevcut değil",
        cardNumberExist: "Kart numarası var",
        cardNumberNotExist: "Kart numarası mevcut değil",
        fingerprintExist: "Parmak izi kaydı var",
        fingerprintNotExist: "Parmak izi kaydı mevcut değil",
        faceTemplateExist: "Yüz izi kaydı var",
        faceTemplateNotExist: "Yüz izi kaydı mevcut değil",
        movements: "Yemekhane Hareketleri",
        foodGroup: "Yemek Grubu",
        retailSaleLogs: "Satış Hareketleri",
        newMovement: "Yemek Hareketi Ekle",
        newMovementWarningInfo: "Dikkat : Kişinin yemek grubu bilgisine göre yemek ücreti düşülür.",
        dateMovement: "Hareket Tarihi",
        readerMovement: "Okuyucu",
        diningHall: "Yemekhane",
        startDateMovements: "Başlangıç",
        endDateMovements: "Bitiş",
        searchMovements: "Listele",
        timeMovement: "Zaman",
        deviceMovement: "Geçiş Noktası",
        statusMovement: "Geçiş",
        price: "Ücreti",
        meal: "Öğün",
        manuelMovement: "Manuel Hareket",
        entryMovement: "Giriş",
        exitMovement: "Çıkış",
        passive: "Pasif",
        movementNotRecord: "Hareket kaydı bulunamadı.",
        remainingCredits: "Kalan Kontör",
        availableBalance: "Kalan Bakiye",
        addCredit: "Kontör Yükle",
        addBalance: "Bakiye Yükle",
        amountOfCredit: "Yüklenecek Kontör Miktarı",
        amountOfBalance: "Yüklenecek Bakiye Miktarı",
        foodBalanceLogs: "Yemek Bakiye Hareketleri",
        time: "Zaman",
        amount: "Miktar",
        type: "Tip",
        status: "Durum",
        foodBalanceLogNotRecord: "Bakiye hareket kaydı bulunamadı.",
        isContinueUpdateEmployeeFoodGroup: "Seçilen kişinin yemek grubu güncellenecektir. Devam edilsin mi?",
      },
      foodGroups: {
        foodGroupList: "Yemek Grubu Listesi",
        foodGroupNotRecord: "Yemek grubu kaydı bulunamadı.",
        foodGroupInformation: "Yemek Grubu Bilgisi",
        newFoodGroup: "Yeni Grup",
        groupName: "Grup Adı",
        groupType: "Grup Tipi",
        deserveType: "Hak Tipi",
        creditType: "Kontör Tipi",
        balanceType: "Bakiye Tipi",
        dailyMealEatingCount: "Günlük Yemek Yeme Adeti",
        meals: "Öğünler",
        mealDefinitions: "Öğün Tanımları",
        newMeal: "Yeni Öğün",
        mealNotFoundSelectedFoodGroups: "Seçilen yemek grubuna ait öğün bulunmuyor.",
        foodGroupUpdateIsContinue: "Seçilen yemek grubu güncellenecektir. Devam edilsin mi?",
        foodGroupSaveIsContinue: "Yeni yemek grubu kaydedilecektir. Devam edilsin mi?",
        foodGroupDeleteIsContinue: "Seçilen yemek grubu silinecektir. Devam edilsin mi?",
        addNewMeal: "Yeni Öğün Ekle",
        validDays: "Geçerli Günler",
        mealName: "Öğün Adı",
        startTime: "Başlangıç Zamanı",
        endTime: "Bitiş Zamanı",
        eatingCount: "Yemek Yeme Adeti",
        price: "Ücret",
        guestPrice: "Misafir Ücreti",
        mealNameDefinitions: "Öğün İsim Tanımları",
        mealNameList: "Öğün İsim Listesi",
        newMealName: "Yeni Öğün Adı",
        mealNameNotRecord: "Öğün adı kaydı bulunamadı.",
      },
      extraFields: {
        extraFieldList: "Özel Alan Listesi",
        extraFieldNotRecord: "Özel alan kaydı bulunamadı.",
        extraFieldInfo: "Özel Alan Bilgisi",
        newGroup: "Yeni Özel Alan",
        groupName: "Özel Alan Adı",
        isContinueUpdate: "Seçilen özel alan güncellenecektir. Devam edilsin mi?",
        isContinueSave: "Yeni özel alan kaydedilecektir. Devam edilsin mi?",
        isContinueDelete: "Seçilen özel alan silinecektir. Devam edilsin mi?",
      },
      licensePlateRecognition: {
        searchLicensePlateInList: "Listeden plaka arayın",
        licensePlateList: "Plaka Listesi",
        licensePlateSearchNotFound: "Plaka kaydı bulunamadı.",
        licensePlateInfo: "Plaka Bilgileri",
        newLicensePlate: "Yeni Plaka",
        updateLicensePlate: "Plakayı Güncelle",
        saveLicensePlate: "Plakayı Kaydet",
        deleteLicensePlate: "Plakayı Sil",
        plateNumber: "Plaka Numarası",
        plateNumberExist: "Plaka numarası var",
        plateNumberNotExist: "Plaka numarası mevcut değil",
        employee: "Kişi",
        deviceList: "Terminal Listesi",
        selectAll: "Tümünü Seç",
        removeAll: "Tümünü Kaldır",
        sendToReader: "Okuyucuya Gönder",
        deviceNotRecord: "Terminal kaydı bulunamadı.",
        isContinueUpdateLicensePlate: "Seçilen plaka güncellenecektir. Devam edilsin mi?",
        isContinueSaveLicensePlate: "Yeni plaka kaydedilecektir. Devam edilsin mi?",
        isContinueDeleteLicensePlate: "Seçilen plaka silinecektir. Devam edilsin mi?",
      },
      departments: {
        departmentInfo: "Departman Bilgisi",
        newDepartment: "Yeni Departman",
        departmentName: "Departman Adı",
        mainDepartment: "Ana Departman",
        indexNumber: "Sıra Numarası",
        departmentList: "Departman Listesi",
        displayOnDashboard: "Kontrol Panelinde Göster",
        departmentNotRecord: "Departman kaydı bulunamadı.",
        isContinueDepartmentUpdate: "Seçilen departman güncellenecektir. Devam edilsin mi?",
        isContinueDepartmentSave: "Yeni departman kaydedilecektir. Devam edilsin mi?",
        isContinueDepartmentDelete: "Seçilen departman silinecektir. Devam edilsin mi?",
      },
      accessGroups: {
        accessGroupList: "Geçiş Grubu Listesi",
        accessGroupNotRecord: "Geçiş grubu kaydı bulunamadı.",
        accessGroupInfo: "Geçiş Grubu Bilgisi",
        newAccessGroup: "Yeni Geçiş Grubu",
        accessGroupName: "Geçiş Grubu Adı",
        addNewDevicesAutomatically: "Yeni Terminaller Otomatik Eklensin",
        authorizedDevices: "Yetkili Terminaller",
        deviceNotRecord: "Terminal kaydı bulunamadı.",
        applyTemplate: "Şablonu Uygula",
        isContinueAccessGroupUpdate: "Seçilen geçiş grubu güncellenecektir. Devam edilsin mi?",
        isContinueAccessGroupSave: "Yeni geçiş grubu kaydedilecektir. Devam edilsin mi?",
        isContinueAccessGroupDelete: "Seçilen geçiş grubu silinecektir. Devam edilsin mi?",
      },
      workPlans: {
        workPlanList: "Çalışma Plan Listesi",
        period: "Periyod",
        singlePlan: "Tekli Çalışma",
        workPlanNotRecord: "Çalışma planı kaydı bulunamadı.",
        workPlanInfo: "Çalışma Planı Bilgisi",
        workPlanModel: "Çalışma Planı Modeli",
        newWorkPlan: "Yeni Çalışma Planı",
        defaultWorkPlanModel: "Varsayılan Çalışma Planı Modeli",
        workGroupModel: "Çalışma Grubu Modeli",
        hourBasedPlanningModel: "Saat Bazlı Çalışma Modeli",
        freelanceModelWithHourlyInterval: "Saat Bazlı Serbest Çalışma Modeli",
        plan1Title: "Standart çalışmalar ve dönüşümlü vardiyalar",
        plan1Description: "Gün bazlı saat aralıkları girerek plan detaylarını oluşturun.",
        plan2Title: "Plansız dönüşümlü vardiya olan yerler",
        plan2Description: "Oluşturulan çalışma planlarını gruplandırarak otomatik olarak algılanmasını sağlar.",
        plan3Title: "Mağazacılık Sektörü",
        plan3Description: "Sadece giriş çıkış saatlerini ve uygulanacak toleransları planlayın.",
        plan4Title: "Saat sınırlaması olmayan yerler",
        plan4Description: "Toplam çalışılması gereken saati ve mola süresi girerek planlayın.",
        details: "Detaylar",
        settings: "Ayarlar",
        plan: "Plan",
        calculateBasedOnFirstEntryAndLastExit: "İlk giriş ve son çıkışı baz alarak hesapla (aradaki hesaplar baz alınmaz)",
        shortCode: "Kısa Kodu",
        workPlanName: "Çalışma Planı Adı",
        entryTime: "Giriş",
        exitTime: "Çıkış",
        tolerances: "Toleranslar",
        earlyEntryTolerance: "Erken Giriş Toleransı",
        earlyExitTolerance: "Erken Çıkış Toleransı",
        lateEntryTolerance: "Geç Giriş Toleransı",
        lateExitTolerance: "Geç Çıkış Toleransı",
        mealBreakTime: "Yemek Molası",
        mealStartTime: "Yemek Başlangıç",
        mealEndTime: "Yemek Bitiş",
        totalMealTime: "Toplam Yemek Zamanı",
        totalWorkTime: "Toplam Çalışma Zamanı",
        breakTolerances: "Mola Toleransları",
        createSettingsForDeservedBreaks: "Hakedilen molalar için ayar oluşturun.",
        forHourlyWork: "saatlik çalışma için",
        break: "mola",
        hourlyWork: "Saatlik İş",
        breakTolerance: "Mola Toleransı",
        notRecord: "Kayıt seçilmedi.",
        durationOfAbsence: "Devamsızlıkta Kesilecek Süre",
        skipTheDayTime: "Gün Atlatma Zamanı",
        solsticeTime: "Gün Dönüm Zamanı",
        maxLimit: "Üst Sınır",
        minLimit: "Alt Sınır",
        basedOnEntryDay: "Giriş yapılan günü esas al",
        checkTheDoors: "Kapı kontrolü yap",
        payrollDetails: "Puantaj Detayları",
        toleranceToReduceTheSameMovementsToOne: "Aynı Hareketleri Teke İndirme Toleransı",
        includeDifferentDoorsInDeleting: "Farklı kapıları silmeye dahil et",
        dontDeleteConfirmedOvertimes: "Onaylanan fazla mesaileri silme",
        selectThePlansYouWantToIncludeInTheGroup: "Gruba dahil etmek istediğiniz planları seçin.",
        currentDefinitionBetweenSelectedHours: "Seçilen saatler için geçerli puantaj",
        whenItDoesntComePerceiveItAsADeserved: "Gelmediğinde hakediş olarak algıla",
        start: "Başlangıç",
        end: "Bitiş",
        payrollType: "Puantaj Tipi",
        deserve: "Hakediş",
        planType: "Plan Tipi",
        periodDistribution: "Periyod Dağılımı",
        periodStartDate: "Periyod Başlangıç Tarihi",
        allowence: "İZİN",
        day: "Gün",
        name: "Adı",
        dayCount: "Gün Sayısı",
        isContinueWorkPlanUpdate: "Seçilen çalışma planı güncellenecektir. Devam edilsin mi?",
        isContinueWorkPlanSave: "Yeni çalışma planı kaydedilecektir. Devam edilsin mi?",
        isContinueWorkPlanDelete: "Seçilen çalışma planı silinecektir. Devam edilsin mi?",
      },
      overtimeDefinitions: {
        overtimePlaces: "Fazla Mesai Yerleri",
        overtimePlaceNotRecord: "Fazla mesai yeri kaydı bulunamadı.",
        overtimeDescriptions: "Fazla Mesai Nedenleri",
        overtimeDescriptionNotRecord: "Fazla mesai nedeni kaydı bulunamadı.",
        newOvertimePlaceDefinition: "Yeni Fazla Mesai Yeri Tanımı",
        overtimePlaceName: "Fazla Mesai Yeri Adı",
        overtimePlaceUpdate: "Fazla Mesai Yeri Güncelle",
        isContinueOvertimePlaceDelete: "Seçilen fazla mesai yeri kaydı silinecektir. Devam edilsin mi?",
        newOvertimeDescriptionDefinition: "Yeni Fazla Mesai Nedeni Tanımı",
        overtimeDescriptionName: "Fazla Mesai Neden Adı",
        overtimeDescriptionUpdate: "Fazla Mesai Nedeni Güncelle",
        isContinueOvertimeDescriptionDelete: "Seçilen fazla mesai nedeni silinecektir. Devam edilsin mi?",
      },
      allowences: {
        allowenceList: "İzin Listesi",
        allowenceNotRecord: "İzin kaydı bulunamadı.",
        allowenceInfo: "İzin Bilgisi",
        newAllowence: "Yeni İzin",
        shortCode: "Kısa Kodu",
        allowenceName: "İzin Adı",
        monthlyPayrollColumn: "Aylık Puantaj Kolonu",
        dailyPayrollColumn: "Günlük Puantaj Kolonu",
        fullWorkTimeInDay: "Tam Gün Süresi",
        color: "Renk",
        isContinueAllowenceUpdate: "Seçilen izin güncellenecektir. Devam edilsin mi?",
        isContinueAllowenceSave: "Yeni izin kaydedilecektir. Devam edilsin mi?",
        isContinueAllowenceDelete: "Seçilen izin silinecektir. Devam edilsin mi?",
      },
      inventoryManagement: {
        inventoryCategories: "Demirbaş Kategorileri",
        inventoryCategoryInfo: "Kategori Bilgisi",
        newInventoryCategory: "Yeni Kategori",
        inventoryCategoryName: "Kategori Adı",
        inventoryCategoryList: "Kategori Listesi",
        inventoryCategoryNotRecord: "Demirbaş kategori kaydı bulunamadı.",
        isContinueInventoryCategoryUpdate: "Seçilen demirbaş kategori güncellenecektir. Devam edilsin mi?",
        isContinueInventoryCategorySave: "Yeni demirbaş kategori kaydedilecektir. Devam edilsin mi?",
        isContinueInventoryCategoryDelete: "Seçilen demirbaş kategori silinecektir. Devam edilsin mi?",
        inventoryWarehouses: "Demirbaş Depoları",
        inventoryWarehouseInfo: "Depo Bilgisi",
        newInventoryWarehouse: "Yeni Depo",
        inventoryWarehouseName: "Depo Adı",
        inventoryWarehouseList: "Depo Listesi",
        inventoryWarehouseNotRecord: "Demirbaş depo kaydı bulunamadı.",
        isContinueInventoryWarehouseUpdate: "Seçilen demirbaş depo güncellenecektir. Devam edilsin mi?",
        isContinueInventoryWarehouseSave: "Yeni demirbaş depo kaydedilecektir. Devam edilsin mi?",
        isContinueInventoryWarehouseDelete: "Seçilen demirbaş depo silinecektir. Devam edilsin mi?",
        inventoryFieldList: "Özellik Listesi",
        inventoryFieldInfo: "Özellik Bilgisi",
        newInventoryField: "Yeni Özellik",
        inventoryFieldName: "Özellik Adı",
        inventoryFieldNotRecord: "Demirbaş özellik kaydı bulunamadı.",
        isContinueInventoryFieldUpdate: "Seçilen demirbaş özelliği güncellenecektir. Devam edilsin mi?",
        isContinueInventoryFieldSave: "Yeni demirbaş özelliği kaydedilecektir. Devam edilsin mi?",
        isContinueInventoryFieldDelete: "Seçilen demirbaş özelliği silinecektir. Devam edilsin mi?",
        inventoryList: "Demirbaş Listesi",
        inventoryInfo: "Demirbaş Bilgisi",
        newInventory: "Yeni Demirbaş",
        inventoryName: "Adı",
        inventoryCode: "Kodu",
        inventorySerialNo: "Seri No",
        inventoryCategory: "Kategori",
        inventoryDefaultWarehouse: "Depo",
        quantity: "Adet",
        documentType: "Belge Tipi",
        documentDescription: "Belge Açıklaması",
        newDocument: "Yeni Belge",
        editDocument: "Belgeyi Düzenle",
        deleteDocument: "Belgeyi Sil",
        addDocumentFile: "Belge Ekle",
        selectPhoto: "Fotoğraf Seç",
        removePhoto: "Fotoğrafı Kaldır",
        allCategories: "Tüm Kategoriler",
        inventoryNotRecord: "Demirbaş kaydı bulunamadı.",
        isContinueInventoryUpdate: "Seçilen demirbaş güncellenecektir. Devam edilsin mi?",
        isContinueInventorySave: "Yeni demirbaş kaydedilecektir. Devam edilsin mi?",
        isContinueInventoryDelete: "Seçilen demirbaş silinecektir. Devam edilsin mi?",
      },
      workPlaceDefinitions: {
        workPlaceList: "Görev Yeri Listesi",
        workPlaceNotRecord: "Görev yeri kaydı bulunamadı.",
        workPlaceInfo: "Görev Yeri Bilgisi",
        newWorkPlace: "Yeni Görev Yeri",
        workPlaceName: "Görev Yeri Adı",
        workPlaceUpdate: "Görev Yeri Güncelle",
        isContinueWorkPlaceUpdate: "Seçilen görev yeri güncellenecektir. Devam edilsin mi?",
        isContinueWorkPlaceSave: "Yeni görev yeri kaydedilecektir. Devam edilsin mi?",
        isContinueWorkPlaceDelete: "Seçilen görev yeri silinecektir. Devam edilsin mi?",  
      },
      documentDefinitions: {
        documentDefinitionList: "Belge Tanımları Listesi",
        documentDefinitionNotRecord: "Belge tanımı kaydı bulunamadı.",
        documentDefinitionInfo: "Belge Tanımı Bilgisi",
        newDocumentDefinition: "Yeni Belge Tanımı",
        documentDefinitionName: "Belge Adı",
        isContinueDocumentDefinitionUpdate: "Seçilen belge tanımı güncellenecektir. Devam edilsin mi?",
        isContinueDocumentDefinitionSave: "Yeni belge tanımı kaydedilecektir. Devam edilsin mi?",
        isContinueDocumentDefinitionDelete: "Seçilen belge tanımı silinecektir. Devam edilsin mi?",  
      },
      annualPermitGroups: {
        annualPermitGroupList: "Yıllık İzin Grup Listesi",
        annualPermitGroupNotRecord: "Yıllık izin grupları bulunamadı.",
        annualPermitGroupInfo: "Yılık İzin Grubu Bilgisi",
        newAnnualPermitGroup: "Yeni Yıllık İzin Grubu",
        groupName: "Grup Adı",
        start: "Başlangıç",
        end: "Bitiş",
        deservedDay: "Hakedilen Gün",
        annualPermitGroupDetailNotRecord: "Yıllık izin grubu detayı bulunamadı.",
        isContinueAnnualPermitGroupUpdate: "Seçilen yıllık izin güncellenecektir. Devam edilsin mi?",
        isContinueAnnualPermitGroupSave: "Yeni yıllık izin kaydedilecektir. Devam edilsin mi?",
        isContinueAnnualPermitGroupDelete: "Seçilen yıllık izin silinecektir. Devam edilsin mi?",
      },
      scenarios: {
        newScenario: "Yeni Senaryo",
        scenarioDetails: "Senaryo Detayları",
        backToScenarios: "Senaryolara Dön",
        scenarioRecordNotFound: "Senaryo kaydı bulunamadı."
      },
      devices: {
        searchDeviceInList: "Listeden terminal arayın...",
        deviceList: "Liste",
        deviceNotRecord: "Terminal kaydı bulunamadı.",
        deviceInfo: "Terminal Bilgisi",
        newDevice: "Yeni Terminal",
        deviceNumber: "Terminal No",
        serialNo: "Seri No",
        brand: "Markası",
        platform: "Platform",
        feature: "Özellik",
        card: "Kart",
        isPanel: "Panel",
        fingerprint: "Parmak İzi",
        faceRecognition: "Yüz Tanıma",
        hasAntipassback: "Antipassback",
        hasTimeZone: "Zaman Sınırlaması",
        isRealTime: "Canlı İzle",
        isOnlineDevice: "Online Kontrol",
        deviceName: "Terminal Adı",
        ipAddress: "Ip Adresi",
        port: "Port",
        adminPassword: "Admin Şifresi",
        deviceGroup: "Terminal Grubu",
        status: "Durumu",
        readerInformation: "Okuyucu Bilgileri",
        readerList: "Okuyucular",
        newReader: "Yeni Okuyucu",
        selectedDeviceReaderNotFound: "Seçilen terminale ait okuyucu bulunamadı.",
        readerNo: "No",
        readerName: "Okuyucu Adı",
        inputName: "Kapı Adı",
        isMainDoor: "Ana Kapı",
        typeOfUse: "Kullanım Tipi",
        access: "Access",
        pdks: "PDKS",
        diningHall: "Yemekhane",
        licencePlateRecognition: "Plaka Tanıma",
        dormitoryDevice: "Yurt Terminali",
        bellOrAlarm: "Zil & Alarm",
        readerStatus: "Durum",
        entry: "Giriş",
        exit: "Çıkış",
        readerInfo: "Okuyucu kaydetmek için önce terminal kaydedin veya listeden bir seçim yapın.",
        isContinueDeviceUpdate: "Seçilen terminal güncellenecektir. Devam edilsin mi?",
        isContinueDeviceSave: "Yeni terminal kaydedilecektir. Devam edilsin mi?",
        isContinueDeviceDelete: "Seçilen terminal silinecektir. Devam edilsin mi?",
        isContinueReaderUpdate: "Seçilen okuyucu güncellenecektir. Devam edilsin mi?",
        isContinueReaderSave: "Yeni okuyucu kaydedilecektir. Devam edilsin mi?",
        isContinueReaderDelete: "Seçilen okuyucu silinecektir. Devam edilsin mi?",
      },
      deviceOperations: {
        addTask: "Görev Ekle",
        deviceNotRecord: "Terminal kaydı bulunamadı.",
        startTime: "Başlangıç Zamanı",
        selectTask: "İşlem Seçiniz",
        getMovementLogs: "Bilgi topla",
        personSetAndDelete: "Kişi gönder / sil",
        getPersons: "Kişileri Al",
        sendBatchPersonData: "Kişileri toplu gönder",
        updateTime: "Zaman güncelle",
        restart: "Yeniden başlat",
        removeAdminAuthorizes: "Admin yetkilerini kaldır",
        removeAllPerson: "Tüm kişileri sil",
        sendAuthorityGroups: "Yetki gruplarını gönder",
        sendPlate: "Plaka gönder",
        sendBatchPlates: "Toplu plaka gönder",
        repeatDaily: "Günlük Tekrar",
        applyRepeatDaily: "Günlük tekrar etsin",
        repetitionInterval: "Tekrarlama Aralığı",
        oneTimePerDay: "günde 1 kez",
        sendCommand: "Komutu Gönder",
        activeTaskList: "Aktif Görev Listesi",
        person: "Geçerli Kişi",
        task: "İşlem",
        device: "Terminal",
        taskTime: "İşlem Zamanı",
        repeatDay: "Tekrar (Gün)",
        noRepeat: "Tekrar Yok",
        activeTaskNotRecord: "Aktif görev kaydı bulunamadı.",
        isContinueTaskDelete: "Seçilen görev silinecektir. Devam edilsin mi?"
      },
      companySettings: {
        companies: "Şirketler",
        newCompany: "Yeni Şirket",
        companyNotRecord: "Şirket kaydı bulunamadı.",
        companyLogo: "Şirket Logo",
        selectPhoto: "Fotoğraf Seç",
        visitorSettings: "Ziyaretçi Takip Ayarları",
        cardIsNotUsedAccessGroup: "Kart Kullanım Dışıyken Geçiş Grubu",
        cardIsUsedAccessGroup: "Kart Kullanımdayken Geçiş Grubu",
        companyInformation: "Şirket Bilgileri",
        companyName: "Şirket Adı",
        companyTitle: "Şirket Ünvanı",
        phone: "Telefon",
        webSite: "Web Site",
        address: "Adres",
        syncRegistrationNoToDeviceNo: "Sicil numarasını terminal numarasına eşitle",
        isContinueCompanyUpdate: "Seçilen şirket güncellenecektir. Devam edilsin mi?",
        isContinueCompanySave: "Yeni şirket kaydedilecektir. Devam edilsin mi?",
        isContinueCompanyDelete: "Seçilen şirket silinecektir. Devam edilsin mi?"
      },
      users: {
        users: "Kullanıcılar",
        newUser: "Yeni Kullanıcı",
        userNotRecord: "Kullanıcı kaydı bulunamadı.",
        userPhoto: "Kullanıcı Fotoğrafı",
        selectPhoto: "Fotoğraf Seç",
        companyAuthorities: "Yetkili Şirketler",
        companyNotRecord: "Şirket kaydı bulunamadı.",
        userInformation: "Kullanıcı Bilgileri",
        userName: "Kullanıcı Adı",
        userTitle: "Kullanıcı Ünvanı",
        email: "E-posta",
        authorityGroup: "Yetki Grubu",
        password: "Parola",
        repeatPassword: "Tekrar Parola",
        realTimeMonitorGroup: "Canlı İzleme Grubu",
        visitorCardGroup: "Varsayılan Ziyaretçi Kart Grubu",
        activateSmsSystem: "SMS Onayı",
        phoneNumber: "Telefon Numarası",
        departmentNotRecord: "Departman kaydı bulunamadı.",
        reportAuthorities: "Rapor Yetkileri",
        reportNotRecord: "Rapor kaydı bulunamadı.",
        isContinueUserUpdate: "Seçilen kullanıcı güncellenecektir. Devam edilsin mi?",
        isContinueUserSave: "Yeni kullanıcı kaydedilecektir. Devam edilsin mi?",
        isContinueUserDelete: "Seçilen kullanıcı silinecektir. Devam edilsin mi?",
        realTimeMonitorGroups: "Canlı İzleme Grupları",
        realTimeMonitorGroupList: "Canlı İzleme Grup Listesi",
        newRealTimeMonitorGroup: "Yeni Canlı İzleme Grubu",
        realTimeMonitorGroupNotRecord: "Canlı izleme grubu kaydı bulunamadı.",
        groupName: "Grup Adı",
        deviceNotRecord: "Terminal kaydı bulunamadı.",
      },
      userAuthorityGroups: {
        userAuthorityGroupList: "Yetki Grupları",
        userAuthorityGroupNotRecord: "Kullanıcı yetki grubu bulunamadı.",
        userAuthorityGroupInformation: "Kullanıcı Yetki Grubu Bilgisi",
        newAuthorityGroup: "Yeni Yetki Grubu",
        authorityGroupName: "Yetki Grubu Adı",
        description: "Açıklama",
        admin: "Admin",
        user: "Kullanıcı",
        authorityInfo: "Seçim yapılmaz ise tam yetkiye sahip olur.",
        authorities: "İşlem Yetkileri",
        filterAuthorities: "Filtre Yetkileri",
        fullAuthority: "Tam Yetki",
        onlyView: "Sadece Görebilir",
        cantUse: "Kullanamaz",
        isContinueUserAuthGroupUpdate: "Seçilen yetki grubu güncellenecektir. Devam edilsin mi?",
        isContinueUserAuthGroupSave: "Yeni yetki grubu kaydedilecektir. Devam edilsin mi?",
        isContinueUserAuthGroupDelete: "Seçilen yetki grubu silinecektir. Devam edilsin mi?",
      },
      mailSmsSettings: {
        mailSettings: "Mail Ayarları",
        smsSettings: "SMS Ayarları",
        automaticMailList: "Otomatik Mail Listesi",
        mailDetails: "Mail Detayı",
        newMailDefinition: "Yeni Mail Tanımı",
        mailDefinitionName: "Tanım Adı",
        mailHeader: "Mail Konusu",
        mailContent: "Mail İçeriği",
        reportType: "Rapor Tipi",
        mailSendingTime: "Gönderim Zamanı",
        day: "Gün",
        time: "Saat",
        reportsToSubmit: "Gönderilecek Raporlar",
        byCustomFilter: "Özel Filtreye Göre",
        emailAddressesToSend: "Gönderilecek E-posta Adresleri",
        enterAEmail: "E-posta adresi girin",
        filterGroup: "Geçerli Filtre Grubu",
        byAuthorizedEmployees: "Sorumlu Kişilere Göre",
        authorizedEmployees: "Sorumlu Kişiler",

        smsAPIRecordInformation: "SMS API Kayıt Bilgileri",
        requestSentLink: "İstek Gönderilen Bağlantı",
        title: "Başlık",
        apiKey: "API Anahtarı",
        secretKey: "Gizli Anahtar",
        userName: "Kullanıcı Adı",
        password: "Parola",
        smsSystem: "SMS Sistemi",
        active: "Aktif",
        dormitorySMSSettings: "SMS Ayarları",
        smsType: "SMS Tipi",
        smsContentDescription1: "Öğrenci belirtilen saatte giriş yapmadığında gönderilecek içerik",
        smsContentDescription2: "Öğrenci geç giriş yaptığında gönderilecek içerik",
        smsContentDescription3: "Öğrenci izinsiz çıkış yaptığında gönderilecek içerik",
        smsContentDescription4: "Öğrenciye izin verildiğinde veliyi bilgilendiren içerik",
        parameters: "Parametreler",
        studentName: "Öğrenci Adı",
        todaysDate: "Bugünün Tarihi",
        movementDate: "Hareket Tarihi",
        movementTime: "Hareket Saati",
        allowenceStartDate: "İzin Başlangıç Tarihi",
        allowenceEndDate: "İzin Bitiş Tarihi",
        allowenceName: "İzin Adı",
        dormitorySMSTimePlan: "Saat Planı",
        lastEntryTime: "Son Giriş Zamanı",
        updateInformation: "Bilgileri Güncelle",
      },
      userLogs: {
        user: "Kullanıcı",
        userLogList: "Kullanıcı İşlem Listesi",
        userLogs: "Kullanıcı İşlem Kayıtları",
        userName: "Kullanıcı Adı",
        logTime: "İşlem Zamanı",
        logDescription: "İşlem Açıklaması",
        logNotRecord: "Kullanıcı işlem kaydı bulunamadı.",
      },
      payrollTypes: {
        payrollTypeList: "Puantaj Tipi Listesi",
        payrollTypeNotRecord: "Puantaj tipi kaydı bulunamadı.",
        payrollTypeInfo: "Puantaj Tipi Bilgisi",
        newPayrollType: "Yeni Puantaj Tipi",
        shortCode: "Kısa Kodu",
        payrollName: "Puantaj Adı",
        payrollType: "Puantaj Tipi",
        payrolls: {
          normalWork: "Normal Çalışma",
          weekendHoliday: "Hafta Tatili",
          publicHoliday: "Resmi Tatil",
          annualPermit: "Yıllık İzin",
          absenteeism: "Devamsızlık",
          missingHour: "Eksik Saat",
          allowence: "İzin",
          overtime: "Fazla Mesai",
          break: "Ara Dinlenme",
          nightOvertime: "Gece Zammı"
        },
        otherPayrollType: "Diğer Puantaj Tipi",
        equalPayrollType: "Eşit Puantaj Tipi",
        monthlyPayrollColumn: "Aylık Puantaj Kolonu",
        maxLimit: "Max Limit",
        multiplier: "Çarpan",
        confirmation: "Onay",
        confirmationRequired: "Onay Gerekli",
        tolerances: "Yuvarlamalar",
        firstTolerance: "İlk",
        lastTolerance: "Son",
        totalTolerance: "Toplam",
        isContinuePayrollTypeUpdate: "Seçilen puantaj tipi güncellenecektir. Devam edilsin mi?",
        isContinuePayrollTypeSave: "Yeni puantaj tipi kaydedilecektir. Devam edilsin mi?",
        isContinuePayrollTypeDelete: "Seçilen puantaj tipi silinecektir. Devam edilsin mi?",
      },
      monthlyPayrollTables: {
        monthlyPayrolColumnlList: "Aylık Puantaj Listesi",
        monthlyPayrollTableRecordNotFound: "Aylık puantaj tablosu kaydı bulunamadı.",
        monthlyPayrollInfo: "Aylık Puantaj Bilgisi",
        newMonthlyPayroll: "Yeni Aylık Puantaj",
        shortCode: "Kısa Kodu",
        payrollColumnName: "Puantaj Kolonu Adı",
        ssk: "SSK",
        total: "Toplam",
        work: "Çalışma",
        isContinueMonthlyPayrollUpdate: "Seçilen aylık puantaj güncellenecektir. Devam edilsin mi?",
        isContinueMonthlyPayrollSave: "Yeni aylık puantaj kaydedilecektir. Devam edilsin mi?",
        isContinueMonthlyPayrollDelete: "Seçilen aylık puantaj silinecektir. Devam edilsin mi?",
      },
      integration: {
        triggerTransfers: "Aktarımları Tetikle",
      },
      support: {
        whatWouldYouLikeSupportOn: "Hangi konuda destek almak istersiniz?",
        subjectYouWantHelpWith: "Destek almak istediğiniz konu",
        searchResults: "Arama Sonuçları",
        noRecordFound: "Sonuç bulunamadı."
      },
      guardTour: {
        guards: "Görevliler",
        newGuard: "Yeni Görevli",
        guardInfo: "Görevli Bilgisi",
        nameSurname: "Ad Soyad",
        title: "Ünvan",
        updatePassword: "Parolayı Güncelle",
        responsibleUserForGuard: "Görevliden Sorumlu Kullanıcı",
        tourCalendar: "Tur Takvimi",
        newCalendar: "Yeni Takvim",
      }
    }),
    new MLanguage('English').create({
      title: 'Hello {0}!',
      general: {
        addNew: "Add New",
        select2: "Select",
        select: "Select",
        notSelected: "Not Selected",
        selected: "Selected",
        notChanged: "Not Changed",
        exportToPdfOrPrint: "Export PDF / Print",
        exportToExcel: "Export to Excel",
        active: "Active",
        passive: "Passive",
        isActive: "Record is Active?",
        view: "View",
        remove: "Remove",
        all: "All",
        selectAll: "Select All",
        removeAll: "Remove All",
        add: "Add",
        added: "Added",
        close: "Close",
        done: "Done",
        doorOpen: "Door Open",
        doorIsClosed: "Door is Closed",
        connected: "Connected",
        notConnected: "Not Connected",
        refreshScreen: "Refresh Screen",
        removed: "Removed",
        cancel: "Cancel",
        save: "Save",
        update: "Update",
        credit: "Credit",
        balance: "Balance",
        delete: "Delete",
        apply: "Apply",
        confirm: "Confirm",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        search: "Search",
        viewQRCode: "View QR Code",
        qRCodeBarcodePrint: "Print QR Code & Barcode",
        qrSettings: "QR Settings",
        qrSize: "Size",
        print: "Print",
        upload: "Upload",
        download: "Download"
      },
      shared: {
        myProfile: "My Profile",
        company: "Company",
        languageOptions: "Language Options",
        changeLanguageInfo: "Select the language you want to change.",
        licenceErrorTitle: "Licence Error",
        licenceError: "Invalid Licence Key!",
        softwareKey: "Software Key",
        softwareKeyDescription: "Forward this code to your company of purchase.",
        enterLicenceKey: "Enter Licence Key",
        licenceKeyDescription: "Enter your license number for the product you have purchased.",
        saveLicenceKey: "Save Licence Key",
        wrongLicenceKey: "Please enter a valid licence key",
        saveLicenceKeySuccessfully: "Licence key save completed successfully!",
        licenceAddTerminalMaxCount: "Maximum number of terminals that can be added to your existing license",
        licenceTerminalDescription: "You need to upgrade your license to add a new terminal. Please contact your reseller to upgrade your license.",
        theme: "Theme",
        themes: {
          blue: "Blue",
          black: "Black",
          purple: "Purple",
          green: "Green",
          red: "Red",
          yellow: "Yellow",
          blueLight: "Blue Light",
          blackLight: "Black Light",
          purpleLight: "Purple Light",
          greenLight: "Green Light",
          redLight: "Red Light",
          yellowLight: "Yellow Light"
        },
        manufacturerInformation: "Manufacturer Information",
        copyright: "Copyright",
        allRightsReserved: "All rights reserved.",
        version: "Version",
        notifications: "Notifications",
        deviceCommunication: "Device Communication",
        notificationNotFound: "Notification not found for user.",
        notificationView: "Total notifications viewed :",
        logOut: "Logout",
        dashboard: "Dashboard",
        realTimeMonitor: "Real Time Monitor",
        employees: "Employees",
        visitors: "Visitors",
        visitorCards: "Visitor Cards",
        visitorReports: "Visitor Reports",
        batchOperations: "Batch Operations",
        reports: "Reports",
        payrollManagement: "Payroll Management",
        shiftManagement: "Shift Management",
        shiftSettings: "Shift Settings",
        studentTransactions: "Student Dormitories",
        areas: "Areas",
        diningHall: "Dining Hall",
        retailSale: "Retail Sale",
        employeeOperations: "Employee Operations",
        foodGroups: "Food Groups",
        diningHallReports: "Dining Hall Reports",
        guardTourSystem: "Guard Tour Control",
        guards: "Guards",
        points: "Points",
        tours: "Tours",
        guardTourReports: "Guard Tour Reports",
        definitions: "Definitions",
        cardDesignTemplates: "Card Templates",
        extraFields: "Custom Fields",
        licensePlateRecognition: "License Plate Recognition",
        departments: "Departments",
        accessGroups: "Access Groups",
        workPlans: "Work Plans",
        overtimeDefinitions: "Overtime Definitions",
        allowences: "Allowences",
        annualPermitGroups: "Annual Permit Groups",
        scenarioList: "Scenario List",
        timeZones: "Time Zones",
        devices: "Devices",
        deviceOperations: "Device Operations",
        settings: "Settings",
        companySettings: "Company Settings",
        users: "Users",
        userAuthorityGroups: "Authority Groups",
        mailSmsSettings: "Mail & SMS Settings",
        userLogs: "User Logs",
        payrollTypes: "Payroll Types",
        monthlyPayrollTables: "Monthly Payroll Tables",
        integration: "Integration",
        support: "Support",
        appAbout: "App About",
        workPlaceDefinitions:"Work Place Definitions",
        inventoryManagement: "Inventory Management",
        inventoryCategories: "Inventory Categories",
        inventoryWarehouses: "Inventory Warehouses",
        inventoryFields: "Inventory Fields",
        documentDefinitions:"Document Definitions",
      },
      filters: {
        filterEmployees: "Employees Filter",
        filterNameSurnameOrCardNo: "Name Surname / Card No",
        filterCitizenshipNumber: "Citizenship No",
        filterRegistrationOrDeviceNo: "Registration No / Device No",
        filterDocumentNoOrEmail: "Email",
        filterTitle: "Title",
        filterState: "State",
        filterStatus: "Status",
        filterAccessGroup: "Access Group",
        filterWorkPlan: "Work Plan",
        filterFoodGroup: "Food Group",
        filterAllowence: "Allowence",
        filterDepartments: "Departments",
        filterDepartmentNotRecord: "No department record found.",
        filterDeleted: "Deleted",
        filterNotShow: "Not Show",
        filterVisitorCards: "Visitor Cards",
        filterShow: "Show",
        filterSelectExtraFields: "Select Custom Field",
        filterCancel: "Cancel",
        filterClear: "Clear",
        filterApply: "Filter Apply",
        filterValue: "Value",
        filterComplete: "Complete",
        filterPlateNo: "Plate No",
        searchEmployeeFromList: "Search employee from list...",
        employeeList: "Employee List",
        employeeNotRecord: "No employee record found.",
      },
      alerts: {
        fileSizeIsTooHigh: "File size is too high...",
        pleaseCheckTheFileFormat: "Please check the file format...",
        pleaseSelectFile: "Please select a file...",
        pleaseSelectADocumentDefinition: "Please select a document type",
        fileUploadSuccessfull: "File uploaded successfully!",
        departmentAndMainDepartmentOverlap: "Department and main department overlap...",
        wrongEmail: "Please enter a valid email",
        wrongEmailOrUsername: "Please enter a valid email or username",
        wrongPassword: "Please check your password",
        undefinedUser: "Undefined user",
        userNotFound: "User not found",
        salaryNameNotBlank: "Payment & deduction name cannot be blank...",
        savedSuccessfully: "Saved successfully!",
        updatedSuccessfully: "Updated successfully!",
        deletedSuccessfully: "Deleted successfully!",
        visitorCardGroupNameNotBlank: "Card group name cannot be blank...",
        statusNameNotBlank: "Status name cannot be blank...",
        stateNameNotBlank: "State name cannot be blank...",
        selectedDayNotMissingHour: "No missing hours for the selected day",
        invalidDate: "Please enter a valid date...",
        notSelectedReader: "Please select a reader...",
        cannotCreateMovementInTheFuture: "You cannot create a movement for the future movements...",
        getReadersError: "Error get readers...",
        creditNotBlank: "Please enter a credit...",
        commandSendToReaderSuccessfully: "Command send to reader successfully!",
        commandSentToDevicesSuccessfully: "Authorization commands sent to terminals successfully!",
        getUserInfoFromTerminalsSuccessfully: "Contact information from terminals successfully requested!",
        getFaceTemplateFromSuccessfully: "Face template information of the employee was successfully requested from the terminals!",
        getFingerprintFromUsbReader: "Fingerprint information of the employee was successfully requested from the usb reader!",
        getFingerprintsFromTerminalsSuccessfully: "Fingerprint information of the employee was successfully requested from the terminals!",
        confirmedOvertimeCannotBeGreaterThanCalculated: "Confirmed overtime cannot be greater than calculated...",
        selectedEmployeeNotBlank: "Please select employee...",
        selectedReportNotBlank: "Please select report...",
        invalidPrice: "Please check the amount...",
        invalidSalaryType: "Please select payment & deduction...",
        employeeRegistrationNumberNotBlank: "Registration number cannot be blank...",
        employeeNameNotBlank: "Name, surname cannot be blank...",
        employeeDepartmentNotBlank: "Department cannot be blank...",
        employeeDeviceNoNotBlank: "Device number cannot be blank...",
        employeeStartDateNotBlank: "Start date of work cannot be blank...",
        employeeTitleNotBlank: "Title cannot be blank...",
        employeeIdentityNoNotBlank: "Identity number cannot be blank...",
        employeeEndDateNotBlank: "End date cannot be blank...",
        employeeWorkGroupIdNotBlank: "Work group cannot be blank...",
        employeeStateIdNotBlank: "State cannot be blank...",
        employeeStateNoteNotBlank: "State note cannot be blank...",
        employeeStatuIdNotBlank: "Status cannot be blank...",
        employeeCardNoNotBlank: "Card number cannot be blank...",
        employeeTerminalStatuNotBlank: "Terminal status cannot be blank...",
        employeeTerminalPasswordNotBlank: "Terminal password cannot be blank...",
        employeeTzCodeNotBlank: "Tz code cannot be blank...",
        employeePlateNoNotBlank: "Plate number cannot be blank...",
        employeeHgsNoNotBlank: "Hgs number cannot be blank...",
        employeeDocumentNoNotBlank: "Document number cannot be blank...",
        visitorCardRegistrationNumberNotBlank: "Registration number cannot be blank...",
        visitorCardNameNotBlank: "Card name cannot be blank...",
        visitorCardDeviceNoNotBlank: "Device number cannot be blank...",
        visitorCardCreateDateNotBlank: "Create date cannot be blank...",
        userIsNotAuthorizedToSeeData: "User is not authorized to see data",
        payrollOfTheEmployeeWasRecalculated: "Payroll of the employee was recalculated",
        confirmedOvertimeDeleted: "Confirmed overtime was deleted",
        youAreOnlyAuthorizedToViewThisPage: "You are only authorized to view this page...",
        attentionPersonIsInBlackList: "Attention! Person is in black list!",
        cardIsUsed: "Card is being used now!",
        unableToConnectPageRefreshing: "Unable to connect... Page refreshing...",
        attentionPersonIsInBlackListNotBeenUpdated: "Attention! This person has not been updated. Because person is in black list!",
        visitorIdentityNumberNotBlank: "Identity number cannot be blank...",
        visitorNameNotBlank: "Visitor name cannot be blank...",
        visitorSuccessfullyExit: "Successfully logged out.",
        checkConfirmedTimes: "There are confirmed entries greater than the calculated time. Please check confirmed times...",
        confirmationOvertimeSuccessfully: "Overtime confirmation process completed successfully!",
        payrollOfTheEmployeesWasRecalculated: "Payroll of the employees was recalculated",
        allowenceNotSelected: "Please select allowence...",
        selectedRecordNotFound: "No selected record found.",
        recordNotFound: "No record found.",
        batchInformationUpdateSuccessfully: "Batch information update completed successfully!",
        batchWorkPlanUpdateSuccessfully: "Batch work plan update completed successfully!",
        batchMovementSuccessfully: "Batch movements save completed successfully!",
        checkTheMealTime: "There is no defined meal at the entered time. Please check the meal time...",
        mealNameNotBlank: "Meal name cannot be blank",
        selectedMealNotBlank: "Please select meal",
        invalidTimeRange: "Please check time range",
        foodGroupNameNotBlank: "Food group name cannot be blank",
        selectedDepartmentNotBlank: "Please select department...",
        selectedAccessGroupNotBlank: "Please select access group",
        accessGroupNameNotBlank: "Access group name cannot be blank",
        pleaseCheckTimes: "Please check the times entered",
        pleaseSelect: "Please select...",
        pleaseEnterShortCodeAndName: "Please enter short code and name",
        pleaseEnterAName: "Please enter a name",
        pleaseEnterAEmail: "Please enter a e-mail",
        pleaseCheckEnteredValue: "Please check entered value",
        pleaseEnterADeviceNo: "Please enter a device number",
        pleaseEnterADeviceName: "Please enter a device name",
        pleaseEnterIpAddressAndPort: "Please enter Ip address and port",
        pleaseEnterAReaderName: "Please enter a reader name",
        pleaseReaderNoOrPressButtonNewReader: "Please enter a reader no or press button on new reader",
        pleaseSelectReader: "Please select reader",
        pleaseCheckFoodGroupAndDate: "Please check that the food group is selected and the date is correct...",
        insufficientBalance: "Insufficient balance!",
        pleaseEnterAmount: "Please enter amount...",
        noContactInformation: "No contact information...",
        pleaseEnterADate: "Please enter a date",
        pleaseEnterACompanyName: "Please enter a company name",
        pleaseEnterAUserName: "Please enter a user name",
        pleaseEnterAPassword: "Please enter a password",
        passwordsDoNotMatch: "Passwords do not match",
        pleaseSelectAuthorityGroup: "Please select authority group",
        pleaseCheckEmptyFields: "Please check empty fields",
        transfersTriggeredSuccessfully: "Transfer triggered successfully!",
        pleaseSelectFile: "Please select file",
        transactionSuccessfull: "Transaction successful!",
        youAreNotAuthorizedForThisAction: "You are not authorized for this action..."
      },
      errors: {
        connectionError: "Connection error: service could not be reached"
      },
      loginPage: {
        select: "Select",
        welcome: 'Please enter your user information to login.',
        fullScreenInfo: "Press the 'F11' key for full screen use.",
        loginButton: "Login",
        emailOrUsername: "Email or username",
        password: "Password",
        title1: "Modern Interface",
        title2: "Flexible Platform",
        title3: "Easy User Interface",
        title4: "Fast Support",
        infoTitle1: "Modern Interface",
        infoContent1: "Unlimited access from anywhere with mobile compatible interface",
        infoTitle2: "Cross Platform",
        infoContent2: "Windows, Linux, Mac, Pardus etc. operating systems support",
        infoTitle3: "Flexible Database",
        infoContent3: "MSSQL, PostgreSQL etc. working with all relational database types",
        infoTitle4: "Unlimited Users",
        infoContent4: "Unlimited users and easy UI",
        infoTitle5: "Unlimited Sub Groups",
        infoContent5: "Special filtering with unlimited and flexible infrastructure",
        infoTitle6: "Flexible Working Types",
        infoContent6: "Working type support suitable for every sector",
        infoTitle7: "Detailed Reports",
        infoContent7: "Flexible report types and one-click export",
        infoTitle8: "Automatic Mail",
        infoContent8: "Automatic report sending to the desired people",
        infoTitle9: "Real Time Monitoring",
        infoContent9: "Real-time viewing of transitions",
        infoTitle10: "Language options",
        infoContent10: "Customizable language options for each user",
        infoTitle11: "Flexible Infrastructure",
        infoContent11: "Infrastructure open to development and integration",
        infoTitle12: "Unlimited Updates",
        infoContent12: "Fast support and unlimited update service",
      },
      dashboard: {
        startOfWorks: "Start of works",
        absentees: "Absentees",
        totalEmployee: "Total Employees",
        lateComers: "Late Comers",
        lastUpdate: "Last Update",
        deviceStatus: "Device Status",
        device: "Device",
        lastConnection: "Last Connection",
        status: "Status",
        deviceNotFound: "Device not found",
        allowenceRequests: "Allowence Requests",
        allowenceRequest: "Allowence Request",
        allowenceRequestNotFound: "Allowence request not found",
        allowenceHeadNameAndDescription: "Name / Description",
        allowenceHeadRequestedDates: "Requested Dates",
        viewDetails: "View details",
        upcomingBirthdays: "Upcoming Birthdays",
        upcomingBirthdaysNotFound: "Upcoming birthdays not found",
        insides: "Insides",
        outsides: "Outsides",
        allowenceEmployees: "Persons on leave",
        insideVisitors: "Inside visitors",
        insideCar: "Inside cars",
        outsideCar: "Outside cars",
        registeredMobileAppUser: "Registered Mobile App Users",
        activeMobileAppUser: "Active Mobile App Users",
        activeStudentsInDormitory: "Active students",
        insideStudentsInDormitory: "Inside students",
        outsideStudentsInDormitory: "Outside students",
        allowencedStudentsInDormitory: "Allowenced students",
        fastReportView: "Fast Report View",
        fastReportTitleTodayStartOfWorks: "Today Start of Works",
        fastReportTitleTodayAbsentees: "Today Absentees",
        fastReportTitleTotalEmployees: "Total Employees",
        fastReportTitleTodayLateComers: "Today Late Comers",
        fastReportTitleInsides: "Inside Employees",
        fastReportTitleOutsides: "Outside Employees",
        fastReportTitleTodayAllowence: "Today Allowenced Employees",
        fastReportTitleInsideVisitors: "Inside Visitors",
        fastReportTitleInsideCars: "Inside Cars",
        fastReportTitleOutsideCars: "Outside Cars",
        fastReportTitleActiveStudents: "Active Students in Dormitory",
        fastReportTitleInsideStudents: "Inside Students in Dormitory",
        fastReportTitleOutsideStudents: "Outside Students in Dormitory",
        fastReportTitleAllowencedStudents: "Allowenced Students in Dormitory",
        fastReportTitleMobileAppUsers: "Mobile App Users",
        fastReportTitleActiveMobileAppUsers: "Active Mobile App Users",
        fastReportNotRecord: "No record found.",
        fastReportHeaderItems: {
          registrationNumber: "Registration Number",
          name: "Name",
          department: "Department",
          datetime: "Time",
          status: "Status",
          citizenshipNumber: "Citizenship Number",
          visitorName: "Visitor Name",
          entryTime: "Entry Time",
          title: "Title",
          mobilePhone: "Mobile Phone",
          device: "Device Model",
          readerName: "Reader Name",
        }
      },
      realTimeMonitor: {
        inputStatus: "Input Status",
        openDoor: "Open Door",
        relayDelay: "Relay Delay",
        pleaseEnterRelayDelay: "Please enter relay delay time in seconds",
        openDoorCommandSentSuccessfully: "Open door command sent successfully!",
        foodMenuAndView: "Food Menu and Live View",
        entryExitList: "Entry or Exit List",
        lastEntry: "Last Entry",
        lastExit: "Last Exit",
        logNotFoundInfo: "When there is a transition movement, it will be listed in this area.",
        foodMenu: "Meal Menu",
        todayTotalFood: "Total Meals Eaten Today",
        entryOrExitLogInfo: "Log Info",
        logTime: "Log Time",
        logDescription: "Log Description",
        mealPay: "Meal Pay",
        availableBalance: "Available Balance",
        movementLogDescription: {
          moveIn: "Move in",
          entryIn: "Entry in",
          exitOut: "Exit Out",
          unregisteredCard: "Unregistered Card",
          noAccess: "No access",
          dailyMealRightExpired: "Daily meal right expired",
          mealClaimExpired: "Meal claim expired",
          insufficientBalance: "Insufficient balance",
          foodGroupNotSelected: "Food group not selected",
          timeLimit: "Time limit",
          antipassback: "Antipassback"
        }
      },
      employees: {
        searchEmployeeInList: "Search employee in list",
        employeeList: "Employee List",
        employeeSearchNotFound: "No employee record found.",
        employeeInfo: "Employee Information",
        newEmployee: "New Employee",
        updateEmployee: "Update Employee",
        saveEmployee: "Save Employee",
        deleteEmployee: "Delete Employee",
        selectedDepartment: "Selected Department",
        removePhoto: "Remove",
        selectPhoto: "Select Photo",
        deletedRecord: "Deleted Record",
        recordType: "Record Type",
        employee: "Employee",
        student: "Student",
        doesStayInTheDormitory: "Does stay in the dormitory",
        doesNotStayInTheDormitory: "Does not stay in the dormitory",
        foodClaim: "Food Claim",
        registrationNumber: "Registration No",
        dateOfStartWork: "Start of Work",
        dateOfEndWork: "End of Work",
        dateOfStart: "Start of Date",
        dateOfEnd: "End of Date",
        roomInformation: "Room - Apartment Information",
        validityStartDate: "Validity Start Date",
        validityEndDate: "Validity End Date",
        createValidityDate: "Create Validity Date",
        removeValidityDate: "Remove Validity Date",
        isContinueRemoveValidityDate: "The validity date will be removed. Is continue?",
        createValidityDateDescription: "Enter the validity date you want to create...",
        passwordExist: "Password registration is available",
        passwordNotExist: "No password registration",
        cardNumberExist: "Card number is available",
        cardNumberNotExist: "No card number",
        fingerprintExist: "Fingerprint is available",
        fingerprintNotExist: "No fingerprint",
        faceTemplateExist: "Face template is available",
        faceTemplateNotExist: "No face template",
        fingerPrintInformation: "Finger Print Information",
        fingerPrintDescription: "Please click to select finger for save or delete.",
        isVisitorCard: "Visitor Card",
        visitorCardGroup: "Visitor Card Group",
        visitorCardGroups: "Visitor Card Groups",
        cardGroupList: "Card Group List",
        newCardGroup: "New Card Group",
        visitorCardGroupNotFound: "No visitor card group record found.",
        cardGroupName: "Card Group Name",
        readerNotFound: "No device record found.",
        setLeaveDate: "Set Leave Date",
        backToWork: "Back to Work",
        reActivate: "Reactivate",
        generalInformation: "General Information",
        studentInformation: "Student Information",
        extraFields: "Custom Fields",
        mobileApp: "Mobile App Settings",
        otherInformation: "Other Information",
        accessAuthorities: "Access Authorities",
        movements: "Movements",
        allowences: "Allowences",
        payroll: "Payroll",
        annualPermit: "Annual Permit",
        payments: "Payments",
        foodGroup: "Food Group",
        employeeLogs: "Logs",
        cardPrinting: "Card Print",
        selectTemplate: "Select Template",
        registrationNumberInfo: "Registration No",
        citizenshipNumber: "Citizenship No",
        nameSurname: "Name Surname",
        department: "Department",
        title: "Title",
        dateofBirth: "Date of Birth",
        dateOfStartWorkInfo: "Date of Start Work",
        status: "Status",
        state: "State",
        stateNote: "State Note",
        deviceEmployeeNumber: "Device Number",
        deviceStatus: "Device Status",
        deviceCardNo: "Device Card No",
        devicePassword: "Device Password",
        plateNo: "Plate No",
        hgsNo: "Vehicle Tag No",
        workPlan: "Work Plan",
        documentNo: "Document No",
        salary: "Salary",
        overtimeStatus: "Overtime Status",
        takesOvertime: "Takes Overtime",
        motherName: "Mother Name",
        motherPhone: "Mother Phone",
        fatherName: "Father Name",
        fatherPhone: "Father Phone",
        activateSmsSystem: "Activate SMS System",
        smsSendPhone: "SMS Send Phone",
        createExtraField: "Create",
        extraFieldNoteInfo: "Note : The extra fields opened will be valid for all persons.",
        keyExtraField: "Key",
        valueExtraField: "Value",
        saveExtraField: "Save",
        extraFieldNotRecord: "No custom field record found.",
        email: "Email",
        address: "Address",
        mobileNumber: "Mobile Number",
        internal: "Internal Number",
        mobileBrand: "Device Model",
        notPaired: "Not Paired",
        resetPairing: "Reset Pairing",
        unknown: "Unknown Device",
        isMobileAppUser: "Is Mobile App User?",
        mobileAppPassword: "Mobile App Password",
        qrReaderMode: "QR Reader Mode",
        qrReaderModeAll: "All",
        qrReaderModeOnlyQRCreate: "Create QR Code",
        qrReaderModeOnlyQRRead: "Read QR Code",
        qrReaderModeOnlyWithButton: "With Button",
        qrReaderModeQRCreateAndRead: "Create & Read QR Code",
        qrReaderModeQRReadAndButton: "Read QR Code & With Button",
        qrReaderModeQRCreateAndButton: "Create QR Code & With Button",
        homePhone: "Home Phone",
        gender: "Gender",
        male: "Male",
        female: "Female",
        educationStatus: "EducationStatus",
        primarySchool: "Primary School",
        highSchool: "High School",
        associateDegree: "Associate Degree",
        bachelorDegree: "Bachelor Degree",
        postGraduate: "Post Graduate",
        doctorate: "Doctorate",
        militaryStatus: "Military Status",
        done: "Done",
        exempt: "Exempt",
        smokingStatus: "Smoking Status",
        smoking: "Smoking",
        notSmoking: "Not Smoking",
        maritalStatus: "Marital Status",
        single: "Single",
        married: "Married",
        widow: "Widow",
        drivingLicence: "Driving Licence",
        foreignLanguage: "Foreign Language",
        bloodType: "Blood Type",
        height: "Height",
        weight: "Weight",
        disabledPercent: "Disabled Percent",
        authorizedPerson1: "1. Authorized Person",
        authorizedPerson2: "2. Authorized Person",
        note1: "Note-1",
        note2: "Note-2",
        accessAuthoritiesInfo: "Access Group",
        sendPersontoDevices: "Send Person to Authorized Devices",
        deviceList: "Device List",
        selectAll: "Select All",
        removeAll: "Remove All",
        sendToReader: "Send to reader",
        getFingerprint: "Get fingerprints",
        getFaceTemplate: "Get face template",
        getUserData: "Get user data",
        deviceNotRecord: "No device record found.",
        newMovement: "New Movement",
        allDoors: "All Doors",
        pdks: "PDKS",
        access: "Access",
        diningHall: "Dining Hall",
        licencePlateRecognition: "Licence Plate Recognition",
        dormitoryDevice: "Dormitory Device",
        all: "All",
        active: "Active",
        passive: "Passive",
        startDateMovements: "Start Date",
        endDateMovements: "End Date",
        searchMovements: "Search",
        location: "Location",
        timeMovement: "Time",
        deviceMovement: "Movement Point",
        statusMovement: "Status",
        manuelMovement: "Manuel Movement",
        entryMovement: "Entry",
        exitMovement: "Exit",
        movementNotRecord: "No movement record found.",
        addMovement: "Add Movement",
        editMovement: "Edit Movement",
        typeMovement: "Movement Type",
        readerMovement: "Reader",
        includePassivesMovement: "Include passive movement",
        confirmedOvertimeNotDeleted: "Confirmed overtime not deleted",
        newAllowence: "New Allowence",
        removeAllowence: "Remove Allowence",
        removeAllowenceInSelectedDates: "Remove Allowence In Selected Dates",
        startDateAllowences: "Start Date",
        endDateAllowences: "End Date",
        searchAllowences: "Search",
        startAllowence: "Start",
        endAllowence: "End",
        codeAllowence: "Code",
        nameAllowence: "Name",
        allowenceNotRecord: "No allowence record found.",
        addAllowence: "Add Allowence",
        editAllowence: "Edit Allowence",
        validDays: "Valid Days",
        typeAllowence: "Allowence Type",
        dailyAllowence: "Daily Allowence",
        hourlyAllowence: "Hourly Allowence",
        startTimeAllowence: "Start Time",
        endTimeAllowence: "End Time",
        allowence: "Allowence",
        totalTimeAllowence: "Total Time",
        missingHourAllowence: "Missing Hour",
        isEqualTheMissingTime: "Is equal the missing time?",
        equalTheMissingTime: "Equal the missing time",
        doesApplyHolidays: "Does it also apply to holidays?",
        applyHolidays: "Apply to holidays",
        descriptionAllowence: "Description",
        recalculate: "Recalculate",
        startDatePayrolls: "Start Date",
        endDatePayrolls: "End Date",
        searchPayrolls: "Search",
        payrollNotRecord: "No payroll record found.",
        datePayroll: "Date",
        workPlanPayroll: "Work Plan",
        firstEntry: "First Entry",
        lastExit: "Last Exit",
        calculatedOvertime: "Calc. O.T.",
        confirmedOvertime: "Confirm O.T.",
        confirmTheCalculated: "Confirm the calculated",
        deleteTheConfirmed: "Delete the confirmed",
        annualPermitGroups: "Annual Permit Groups",
        seniority: "Seniority",
        transfer: "Transfer",
        remaining: "Remaining",
        deservedAnnualPermits: "Annual Permits",
        deservedDate: "Date",
        deservedDay: "Day",
        annualPermitNotRecord: "No annual permit record found.",
        usedAnnualPermits: "Used Annual Permits",
        annualPermitDate: "Date",
        annualPermitName: "Name",
        annualPermitDescription: "Description",
        usedAnnualPermitNotRecord: "No used annual permit record found.",
        payments: "Payments",
        paymentDefinitions: "Payment Definitions",
        newPayment: "New",
        startDatePayments: "Start Date",
        endDatePayments: "End Date",
        searchPayments: "Search",
        timePayment: "Time",
        namePayment: "Payment & Deduction Name",
        amountPayment: "Amount",
        statusPayment: "Status",
        addPayment: "Add Payment & Deduction",
        editPayment: "Edit Payment & Deduction",
        typePayment: "Payment & Deduction Type",
        addedSalary: "Increase to Salary",
        decreaseFromSalary: "Decrease from Salary",
        effectOnSalary: "Effect on Salary",
        paymentNotRecord: "No payment & deduction record found.",
        remainingCredits: "Remaining Credits",
        availableBalance: "Available Balance",
        addCredit: "Add Credit",
        addBalance: "Add Balance",
        amountOfCredit: "Amount of Credit",
        amountOfBalance: "Amount of Balance",
        startDateLogs: "Start Date",
        endDateLogs: "End Date",
        searchLogs: "Search",
        timeLog: "Time",
        descriptionLog: "Description",
        logNotRecord: "No log record found.",
        selectEmployee: "Select Employee",
        searchFromNameSurname: "Search from name or surname.",
        isContinueUpdateEmployee: "The selected employee will be updated. Continue?",
        isContinueSaveEmployee: "The new employee will be saved. Continue?",
        isContinueDeleteEmployee: "The selected employee will be deleted. Continue?",
        setLeaveDateInfo: "The selected employee will be dismiss. Please enter the date you wish to dismiss.",
        updateWorkPlan: "Update Work Plan",
        updateAllowence: "Update Allowence",
        updateAllowenceNotRecord: "No record found.",
        updateWorkPlanNotRecord: "No record found.",
        states: "States",
        stateList: "State List",
        newState: "New State",
        stateNotRecord: "No state record found.",
        stateName: "State Name",
        enableToLeaveDate: "Enable to leave date",
        statusTitle: "Status",
        statusList: "Status List",
        newStatus: "New Status",
        statusNotRecord: "No status record found.",
        statusName: "Status Name",
        selectDepartment: "Select Department",
        departmentNotRecord: "No department record found.",
        confirmSelectedOvertime: "Confirm Selected Overtime",
        overtimePlace: "Overtime Place",
        overtimeDescription: "Overtime Description",
        dailyPayrollDetail: "Daily Payroll Detail",
        payrollDetail: "Payroll Detail",
        movementsOT: "Movements",
        payrollTime: "Time",
        movementOT: "Movement",
        statusOT: "Status",
        calculatedOvertimeLong: "Calculated O.T.",
        confirmedOvertimeLong: "Confirmed O.T.",
        workPlaceStartDate: "Start Date",
        workPlaceEndDate: "End Date",
        workPlace: "Work Place",
        workPlaces: "Work Places",
        workPlaceDefinitions: "Work Place Definitions",
        newWorkPlace: "New Work Place",
        workPlaceDescription: "Work Place Description",
        addWorkplace: "Add Work Place",
        editWorkplace: "Edit Work Place",
        descriptionWorkPlace: "Work Place Description",
        salary: "Salary",
        updateTime: "Update Time",
        addSalary: "Add Salary",
        editSalary: "Edit Salary",
        newSalary: "New Salary",
        assignedInventory: "Assigned Inventory"
      },
      visitors: {
        waitingVisitors: "Waiting Visitors",
        blackList: "Black List",
        reasonsForVisit: "Reasons for Visit",
        visitorName: "Visitor Name",
        reasonForVisit: "Reason for Visit",
        appointmentTime: "Appointment Time",
        waitingVisitorNotRecord: "No waiting visitor record found.",
        citizenshipNumber: "Citizenship Number",
        blackListName: "Name",
        blackListDescription: "Description",
        blackListNotRecord: "No black list record found.",
        reasonForVisitNotRecord: "No reason for visit record found.",
        inUse: "In use",
        ready: "Ready",
        givenTemporary: "Given Temporary",
        visitorCardNotRecord: "No visitor card record found.",
        employeeStatus: "Employee Status",
        searchEmployeeFromList: "Search employee from list...",
        searchVisitorCardFromList: "Search visitor card from list...",
        employeeNotRecord: "No employee record found.",
        in: "In",
        out: "Out",
        noLatestStatusInformation: "No latest status information",
        visitorInformation: "Visitor Information",
        previousSimilarRecords: "Previous Similar Records",
        similarRecordNotFound: "Similar record not found.",
        employeeList: "Employee List",
        visitorCard: "Visitor Card",
        temporaryCardForEmployee: "Temporary Card for Employee",
        nameSurname: "Name Surname",
        mobilePhone: "Mobile Phone",
        where: "Where",
        person: "Person",
        company: "Company",
        other: "Other",
        description: "Description",
        visitedEmployeeInformation: "Visited employee information",
        employeeInformation: "Employee information",
        selectEmployee: "Select Employee",
        waitingVisitorInformation: "Waiting Visitor Information",
        employeeSearch: "Employee search...",
        noContactInformation: "No Contact Information",
        visitorCards: "Visitor Cards",
        selectVisitorCardToGive: "Select visitor card to give",
        readyToUseVisitorCardNotRecord: "No ready to use visitor card found.",
        selectVisitorCardGroup: "Select Group",
        isContinueDeleteReason: "The selected reason record will be deleted. Continue?",
        isContinueDeleteBlackList: "The selected person record will be deleted. Continue?",
        isContinueDeleteWaitingVisitor: "The selected waiting visitor record will be deleted. Continue?",

      },
      visitorCards: {
        searchVisitorCardInList: "Search visitor card in list",
        visitorCardList: "Visitor Card List",
        visitorCardSearchNotFound: "No visitor card record found.",
        visitorCardInfo: "Visitor Card Information",
        newVisitorCard: "New Visitor Card",
        updateVisitorCard: "Update Visitor Card",
        saveVisitorCard: "Save Visitor Card",
        deleteVisitorCard: "Delete Visitor Card",
        removePhoto: "Remove",
        selectPhoto: "Select Photo",
        deletedRecord: "Deleted Record",
        registrationNumber: "Registration No",
        dateOfCreate: "Create Date",
        passwordExist: "Password registration is available",
        passwordNotExist: "No password registration",
        cardNumberExist: "Card number is available",
        cardNumberNotExist: "No card number",
        fingerprintExist: "Fingerprint is available",
        fingerprintNotExist: "No fingerprint",
        faceTemplateExist: "Face template is available",
        faceTemplateNotExist: "No face template",
        visitorCardGroup: "Visitor Card Group",
        visitorCardGroups: "Visitor Card Groups",
        cardGroupList: "Card Group List",
        newCardGroup: "New Card Group",
        visitorCardGroupNotFound: "No visitor card group record found.",
        cardGroupName: "Card Group Name",
        readerNotFound: "No device record found.",
        generalInformation: "General Information",
        accessAuthorities: "Access Authorities",
        movements: "Movements",
        employeeLogs: "Logs",
        cardPrinting: "Card Print",
        selectTemplate: "Select Template",
        registrationNumberInfo: "Registration No",
        cardName: "Card Name",
        department: "Department",
        dateOfCreateInfo: "Date of Create",
        status: "Status",
        deviceEmployeeNumber: "Device Number",
        deviceStatus: "Device Status",
        deviceCardNo: "Device Card No",
        devicePassword: "Device Password",
        accessAuthoritiesInfo: "Access Group",
        sendPersontoDevices: "Send Person to Authorized Devices",
        deviceList: "Device List",
        selectAll: "Select All",
        removeAll: "Remove All",
        getFingerprint: "Get fingerprints",
        getFaceTemplate: "Get face template",
        getUserData: "Get user data",
        sendToReader: "Send to reader",
        deviceNotRecord: "No device record found.",
        newMovement: "New Movement",
        allDoors: "All Doors",
        pdks: "PDKS",
        access: "Access",
        diningHall: "Dining Hall",
        all: "All",
        active: "Active",
        passive: "Passive",
        startDateMovements: "Start Date",
        endDateMovements: "End Date",
        searchMovements: "Search",
        timeMovement: "Time",
        deviceMovement: "Movement Point",
        statusMovement: "Status",
        manuelMovement: "Manuel Movement",
        entryMovement: "Entry",
        exitMovement: "Exit",
        movementNotRecord: "No movement record found.",
        remainingCredits: "Remaining Credits",
        availableBalance: "Available Balance",
        addCredit: "Add Credit",
        addBalance: "Add Balance",
        amountOfCredit: "Amount of Credit",
        amountOfBalance: "Amount of Balance",
        startDateLogs: "Start Date",
        endDateLogs: "End Date",
        searchLogs: "Search",
        timeLog: "Time",
        descriptionLog: "Description",
        logNotRecord: "No log record found.",
        isContinueUpdateVisitorCard: "The selected visitor card will be updated. Continue?",
        isContinueSaveVisitorCard: "The new visitor card will be saved. Continue?",
        isContinueDeleteVisitorCard: "The selected visitor card will be deleted. Continue?",
        statusTitle: "Status",
        statusList: "Status List",
        newStatus: "New Status",
        statusNotRecord: "No status record found.",
        statusName: "Status Name",
        selectDepartment: "Select Department",
        departmentNotRecord: "No department record found.",
      },
      batchOperations: {
        filterTheEmployeesYouWantToSelect: "Filter the employees you want to select",
        searchEmployeeFromList: "Search employee from list...",
        employeeList: "Employee List",
        employeeNotRecord: "No employee record found.",
        chooseFromTheFollowingActions: "Choose from the following actions",
        informationUpdate: "Information Update",
        informationUpdateOperations: "Information Update Operations",
        allowence: "Allowence",
        allowenceOperations: "Allowence Operations",
        movement: "Movement",
        movementOperations: "Movement Operations",
        overtime: "Overtime",
        overtimeOperations: "Overtime Operations",
        payroll: "Payroll",
        payrollOperations: "Payroll Operations",
        workPlan: "Work Plan",
        workPlanOperations: "Work Plan Operations",
        accessGroup: "Access Group",
        validityStartDate: "Validity Start Date",
        validityEndDate: "Validity End Date",
        department: "Department",
        status: "Status",
        state: "State",
        foodGroup: "Food Group",
        startDate: "Start Date",
        endDate: "End Date",
        startTime: "Start Time",
        endTime: "End Time",
        validDays: "Valid Days",
        allowence: "Allowence",
        allowenceType: "Allowence Type",
        dailyAllowence: "Daily Allowence",
        hourlyAllowence: "Hourly Allowence",
        totalTimeAllowence: "Total Time",
        missingHourAllowence: "Missing Hour",
        isEqualTheMissingTime: "Is equal the missing time?",
        equalTheMissingTime: "Equal the missing time",
        doesApplyHolidays: "Does it also apply to holidays?",
        applyHolidays: "Apply to holidays",
        descriptionAllowence: "Description",
        movementDetails: "Movement Details",
        movementTime: "Movement Time",
        reader: "Reader",
        movementType: "Movement Type",
        entryMovement: "Entry",
        exitMovement: "Exit",
        createExitMovement: "Create exit movement",
        secondMovementTime: "2.Movement Time",
        secondMovementReader: "2.Movement Reader",
        secondMovementType: "2.Movement Type",
        confirmOvertime: "Confirm Overtime",
        search: "Search",
        overtimeWorks: "Overtime Works",
        nameSurname: "Name Surnama",
        date: "Date",
        calculated: "Calculated",
        confirmed: "Confirmed",
        includePassivesMovement: "Include passive movement",
        confirmedOvertimeNotDeleted: "Confirmed overtime not deleted",
        descriptionWorkPlan: "Description",
        batchInformationUpdateSuccessfully: "Bulk information update completed successfully!",
        batchWorkPlanUpdateSuccessfully: "Batch work plan change saved successfully!",
        batchMovementSuccessfully: "Bulk transaction creation successfully saved!",
        batchAllowencesSuccessfully: "Batch permission process completed successfully!",

      },
      reports: {
        selectReport: "Select Report",
        report: "Report",
        noResults: "No results to display.",
        reportDetails: "Report Details",
        displayInReportVisitorCardGroups: "Visitor card groups to display in the report",
        visitorCardGroupNotFound: "No visitor card group record found.",
        displayInReportDevices: "Devices to display in the report",
        devicesNotFound: "No device record found.",
        displayInReportAllowences: "Allowences to display in the report",
        allowenceNotFound: "No allowence record found.",
        displayInReportDepartments: "Departments to display in the report",
        departmentNotFound: "No department record found.",
        checkThisDevices: "Check This Devices",
        reportSettings: "Report Settings",
        startDate: "Start Date",
        endDate: "End Date",
        date: "Date",
        reportOptions: "Report Options",
        showAllowences: "Show Allowences",
        showMissing: "Show Missing",
        showLatecomer: "Show Latecomer",
        fromTheClock: "from the clock",
        lessEmployees: "Less employees",
        moreEmployees: "More employees",
        viewReport: "View Report",
        selectedReportIsUnavailable: "The selected report is unavailable...",
        reports: {
          LaterComersReport: "Later Comers Report",
          LaterComersReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            title: "Title",
            date: "Date",
            status: "Status",
            entry: "Entry",
            difference: "Difference"
          },
          DetailedInOutReport: "Detailed Movement Report",
          DetailedInOutReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            workPlace: "Work Place",
            date: "Date",
            firstEntry: "First Entry",
            lastExit: "Last Exit",
            total: "Total",
            status: "Status",
            entry: "Entry",
            exit: "Exit",
            difference: "Dif."
          },
          FoodReport: "Food Doors Movement Report",
          FoodReportHeader: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            title: "Title",
            documentNo: "Document No",
            departmentName: "Department",
            readerName: "Reader",
            date: "Date",
            debit: "Debit"
          },
          FoodDebtReport: "Food Debt Report",
          FoodDebtReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            documentNo: "Document No",
            debit: "Debit"
          },
          FoodSummaryReport: "Food Summary Report",
          FoodSummaryReportHeaders: {
            departmentName: "Department Name",
            total: "Total",
            debit: "Price",
          },
          EmployeesReport: "Employee Information Report",
          EmployeesReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            title: "Title",
            mobilePhone: "Phone",
            citizenshipNumber: "C.N.",
            status: "Status",
            state: "State",
            startDateWork: "Start Date",
            leaveDate: "Leave Date",
            validityStartDate: "Validity Start Date",
            validityEndDate: "Validity End Date"
          },
          InsidesReport: "Insides Report",
          InsidesReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            entryTime: "Entry Time",
            entryPoint: "Entry Point",
            status: "Status"
          },
          OutsidesReport: "Outsides Report",
          OutsidesReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            exitTime: "Exit Time",
            exitPoint: "Exit Point",
            status: "Status"
          },
          VisitorsReport: "Visitors Report",
          VisitorsReportHeaders: {
            citizenshipNumber: "C.N.",
            nameSurname: "Name Surname",
            mobilePhone: "Phone",
            where: "Visited",
            departmentName: "Department",
            reasonForVisit: "Reason for Visit",
            visitedEmployeeInformation: "Visited",
            cardIssueTime: "Card Issue Time",
            entryTime: "Entry Time",
            exitTime: "Exit Time",
            cardName: "Card Name",
            description: "Description"
          },
          InsideVisitorsReport: "Inside Visitors Report",
          InsideVisitorsReportHeader: {
            citizenshipNumber: "C.N.",
            nameSurname: "Name Surname",
            mobilePhone: "Phone",
            where: "Visited",
            departmentName: "Department",
            reasonForVisit: "Reason for Visit",
            visitedEmployeeInformation: "Visited",
            cardIssueTime: "Card Issue Time",
            entryTime: "Entry Time",
            cardName: "Card Name",
            description: "Description"
          },
          TimeBasedWorkReport: "Time Based Work Report",
          TimeBasedWorkReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            startDate: "Start Date",
            endDate: "End Date",
            totalWorkedTime: "Total Worked Time",
            difference: "Difference"
          },
          FirstInLastOutReport: "First Entry Last Exit Report",
          FirstInLastOutReportHeaders: {
            citizenshipNumber: "Citizenship No",
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            department: "Department",
            title: "Title",
            status1: "Status",
            workPlace: "Work Place",
            workPlan: "Work Plan",
            date: "Date",
            firstEntry: "First Entry",
            entryReader: "Entry Reader",
            lastExit: "Last Exit",
            exitReader: "Exit Reader",
            status: "Status",
            total: "Total Work Time",
            missingHour: "Difference",
            earlyEntry: "Early Entry",
            lateEntry: "Late Entry",
            earlyExit: "Early Exit",
            lateExit: "Late Exit"
          },
          AllowenceReport: "Allowence Report",
          AllowenceReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            startTime: "Start Time",
            endTime: "End Time",
            allowenceName: "Allowence Name"
          },
          WorkSummaryReport: "Work Summary Report",
          WorkSummaryReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            jobDays: "Job Days",
            workDays: "Work Days",
            publicHoliday: "Public Holiday",
            allowence: "Allowence",
            absentee: "Absentee"
          },
          CompanyEmployeesStatusReport: "Unit Based Employee Number Report",
          CompanyEmployeesStatusReportHeaders: {
            unitName: "Unit Name",
            employeeCount: "Employee Count",
            continuedEmployeeCount: "Continued Employee Count",
            annualPermit: "Annual Permit",
            report: "Report",
            administrativeLeave: "Administrative Leave",
            freePermission: "Free Permission",
            missioned: "Missioned",
            nonComers: "Non Comers",
            todayComers: "Today Comers"
          },
          CustomCompanyEmployeesStatusReport: "Department Based Employee Number Report",
          CustomCompanyEmployeesStatusReportHeaders: {
            unitName: "Unit Name",
            employeeCount: "Employee Count",
            continuedEmployeeCount: "Continued Employee Count",
            annualPermit: "Annual Permit",
            report: "Report",
            administrativeLeave: "Administrative Leave",
            freePermission: "Free Permission",
            missioned: "Missioned",
            nonComers: "Non Comers",
            todayComers: "Today Comers"
          },
          DepartmentSummaryReport: "Department Based Employee Number Report With Dates",
          DepartmentSummaryReportHeaders: {
            unitName: "Unit Name",
            employeeCount: "Employee Count",
            continuedEmployeeCount: "Continued Employee Count",
            annualPermit: "Annual Permit",
            report: "Report",
            administrativeLeave: "Administrative Leave",
            freePermission: "Free Permission",
            missioned: "Missioned",
            nonComers: "Non Comers",
            todayComers: "Today Comers"
          },
          PayrollReport: "Payroll Report",
          DetailedPayrollReport: "Detailed Payroll Report",
          FoodCreditReport: "Food Credit Log Report",
          FoodCreditReportHeaders: {
            registrationNumber: "Registration No",
            nameSurname: "Name Surname",
            date: "Date",
            debit: "Debit",
            creditType: "Type",
            status: "Status",
            userName: "User"
          },
          TemplatePayrollReport: "Template Payroll Report",
          TemplateMonthlyPayrollReport: "Monthly Payroll Report",
          SalaryReport: "Salary Report",
          InOutReport: "In Out Report",
          InOutReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            title: "Title",
            workPlace: "Work Place",
            departmentName: "Department",
            location: "Location",
            date: "Date",
            readerName: "Reader"
          },
          DoorBasedLastMovementReport: "Door Based Last Movement Report",
          DoorBasedLastMovementReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            title: "Title",
            departmentName: "Department",
            date: "Date",
            readerName: "Reader",
            doorStatus: "Status"
          },
          DoorsAuthorizationReport: "Doors Authorization Report",
          DoorsAuthorizationReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            title: "Title",
            departmentName: "Department",
            accessGroup: "Access Group"
          },
          DormitoryInformationReport: "Dormitory Students Report",
          DormitoryInformationReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            departmentName: "Department",
            isSmsSend: "SMS Send",
            motherName: "Mother Name",
            fatherName: "Father Name",
            smsPhone: "SMS Phone",
            validityDate: "Validity Date",
            roomName: "Room",
            floorName: "Floor",
            areaName: "Area"
          },
          DormitoryInsidesReport: "Yurt İçerideki Öğrenciler Raporu",
          DormitoryInsidesReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            departmentName: "Department",
            lastMovementDate: "Last Movement",
            lastMovementReader: "Reader",
            status: "Status",
            isSmsSend: "SMS Send",
            motherName: "Mother Name",
            fatherName: "Father Name",
            smsPhone: "SMS Phone",
            validityDate: "Validity Date",
            roomName: "Room",
            floorName: "Floor",
            areaName: "Area"
          },
          DormitoryOutsidesReport: "Yurt Dışarıdaki Öğrenciler Raporu",
          DormitoryOutsidesReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            departmentName: "Department",
            lastMovementDate: "Last Movement",
            lastMovementReader: "Reader",
            status: "Status",
            isSmsSend: "SMS Send",
            motherName: "Mother Name",
            fatherName: "Father Name",
            smsPhone: "SMS Phone",
            validityDate: "Validity Date",
            roomName: "Room",
            floorName: "Floor",
            areaName: "Area"
          },
          WeeklyPayrollReport: "Weekly Payroll Report",
          WeeklyPayrollReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            title: "Title",
            departmentName: "Department",
            workTime: "Work Time",
            overTime: "Overtime",
            nightWorkTime: "Night Work Time",
            status: "Overtime to Pay",
          },
          EntryExitSnapshotReport: "Movement Snapshots Report",
          EntryExitSnapshotReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            title: "Title",
            departmentName: "Department",
            date: "Date",
            reader: "Reader",
            photo: "Profile Picture",
            snapshot: "Snapshot"
          },
          SaleReport: "Sale Report",
          SaleReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            price: "Price",
            date: "Date",
            user: "User",
            isRefund: "Is Refund?"
          },
          DetailedVisitorReport: "Detailed Visitor Report",
          DetailedVisitorReportHeaders: {
            citizenshipNumber: "C.N.",
            nameSurname: "Name Surname",
            mobilePhone: "Phone",
            where: "Visited",
            departmentName: "Department",
            reasonForVisit: "Reason for Visit",
            visitedEmployeeInformation: "Visited",
            cardIssueTime: "Card Issue Time",
            entryTime: "Entry Time",
            exitTime: "Exit Time",
            cardName: "Card Name",
            description: "Description"
          },
          DepartmentBasedVisitorReport: "Department Based Visitor Report",
          DepartmentBasedVisitorReportHeaders: {
            departmentName: "Department",
            total: "Total",
          },
          ShiftReport: "Shift Report",
          ShiftReportHeaders: {
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            title: "Title",
            departmentName: "Department",
            signature: "Signature",
            isSignatureColumnAdded: "Add Signature Column?",
          },
          VerticalFirstInLastOutReport: "Vertical First In Last Out Report",
          VerticalFirstInLastOutReportHeaders: {
            citizenshipNumber: "Citizenship Number",
            registrationNumber: "Registration Number",
            nameSurname: "Name Surname",
            status: "Status",
            title: "Title",
            departmentName: "Department",
          }
        }
      },
      foodGroupOperations: {
        searchEmployeeInList: "Search employee in list",
        employeeList: "Employee List",
        employeeSearchNotFound: "No employee record found.",
        employeeInfo: "Employee Information",
        deletedRecord: "Deleted Record",
        registrationNumber: "Registration No",
        dateOfStartWork: "Start of Work",
        dateOfEndWork: "End of Work",
        passwordExist: "Password registration is available",
        passwordNotExist: "No password registration",
        cardNumberExist: "Card number is available",
        cardNumberNotExist: "No card number",
        fingerprintExist: "Fingerprint is available",
        fingerprintNotExist: "No fingerprint",
        faceTemplateExist: "Face template is available",
        faceTemplateNotExist: "No face template",
        movements: "Dining Hall Movements",
        foodGroup: "Food Group",
        retailSaleLogs: "Sale Logs",
        newMovement: "New Movement",
        newMovementWarningInfo: "Warning : Meal fee is deducted according to the employee's meal group information.",
        dateMovement: "Movement Date",
        readerMovement: "Reader",
        diningHall: "Dining Hall",
        startDateMovements: "Start Date",
        endDateMovements: "End Date",
        searchMovements: "Search",
        timeMovement: "Time",
        deviceMovement: "Movement Point",
        statusMovement: "Status",
        price: "Price",
        meal: "Meal",
        manuelMovement: "Manuel Movement",
        entryMovement: "Entry",
        exitMovement: "Exit",
        passive: "Passive",
        movementNotRecord: "No movement record found.",
        remainingCredits: "Remaining Credits",
        availableBalance: "Available Balance",
        addCredit: "Add Credit",
        addBalance: "Add Balance",
        amountOfCredit: "Amount of Credit",
        amountOfBalance: "Amount of Balance",
        foodBalanceLogs: "Food Balance Logs",
        time: "Time",
        amount: "Amount",
        type: "Type",
        status: "Status",
        foodBalanceLogNotRecord: "No food balance log record found.",
        isContinueUpdateEmployeeFoodGroup: "The food group of the selected employee will be updated. Continue?",
      },
      foodGroups: {
        foodGroupList: "Food Group List",
        foodGroupNotRecord: "No food group record found.",
        foodGroupInformation: "Food Group Information",
        newFoodGroup: "New Food Group",
        groupName: "Group Name",
        groupType: "Group Type",
        deserveType: "Claim Type",
        creditType: "Credit Type",
        balanceType: "Balance Type",
        dailyMealEatingCount: "Daily Meal Eating Right",
        meals: "Meals",
        mealDefinitions: "Meal Definitions",
        newMeal: "New Meal",
        mealNotFoundSelectedFoodGroups: "No meal in food group record found.",
        foodGroupUpdateIsContinue: "Selected food group will be updated. Continue?",
        foodGroupSaveIsContinue: "New food group will be saved. Continue?",
        foodGroupDeleteIsContinue: "Selected food group will be deleted. Continue?",
        addNewMeal: "Add New Meal",
        validDays: "Valid Days",
        mealName: "Meal Name",
        startTime: "Start Time",
        endTime: "End Time",
        eatingCount: "Eating Count",
        price: "Price",
        guestPrice: "Guest Price",
        mealNameDefinitions: "Meal Name Definitions",
        mealNameList: "Meal Name List",
        newMealName: "New Meal Name",
        mealNameNotRecord: "No meal name record found.",
      },
      extraFields: {
        extraFieldList: "Custom Field List",
        extraFieldNotRecord: "No custom field record found.",
        extraFieldInfo: "Custom Field Info",
        newGroup: "New Custom Field",
        groupName: "Custom Field Name",
        isContinueUpdate: "Selected custom field will be updated. Continue?",
        isContinueSave: "New custom field will be saved. Continue?",
        isContinueDelete: "Selected custom field will be deleted. Continue?",
      },
      licensePlateRecognition: {
        searchLicensePlateInList: "Search license plate in list",
        licensePlateList: "License Plate List",
        licensePlateSearchNotFound: "No license plate record found.",
        licensePlateInfo: "License Plate Info",
        newLicensePlate: "New License Plate",
        updateLicensePlate: "Update License Plate",
        saveLicensePlate: "Save License Plate",
        deleteLicensePlate: "Delete License Plate",
        plateNumber: "Plate Number",
        plateNumberExist: "License plate number exists",
        plateNumberNotExist: "License plate number does not exist",
        deviceList: "Terminal List",
        employee: "Employee",
        selectAll: "Select All",
        removeAll: "Remove All",
        sendToReader: "Send to Reader",
        deviceNotRecord: "No terminal record found.",
        isContinueUpdateLicensePlate: "Selected license plate will be updated. Continue?",
        isContinueSaveLicensePlate: "New license plate will be saved. Continue?",
        isContinueDeleteLicensePlate: "Selected license plate will be deleted. Continue?",
      },
      departments: {
        departmentInfo: "Department Info",
        newDepartment: "New Department",
        departmentName: "Department Name",
        mainDepartment: "Main Department",
        indexNumber: "Index Number",
        departmentList: "Department List",
        displayOnDashboard: "Display on Dashboard",
        departmentNotRecord: "No department record found.",
        isContinueDepartmentUpdate: "Selected department will be updated. Continue?",
        isContinueDepartmentSave: "New department will be saved. Continue?",
        isContinueDepartmentDelete: "Selected department will be deleted. Continue?",
      },
      accessGroups: {
        accessGroupList: "Access Group List",
        accessGroupNotRecord: "No access group record found.",
        accessGroupInfo: "Access Group Info",
        newAccessGroup: "New Access Group",
        accessGroupName: "Access Group Name",
        addNewDevicesAutomatically: "Add New Devices Automatically",
        authorizedDevices: "Authorized Devices",
        deviceNotRecord: "No device record found.",
        applyTemplate: "Apply Template",
        isContinueAccessGroupUpdate: "Selected access group will be updated. Continue?",
        isContinueAccessGroupSave: "New access group will be saved. Continue?",
        isContinueAccessGroupDelete: "Selected access group will be deleted. Continue?",
      },
      workPlans: {
        workPlanList: "Work Plan List",
        period: "Period",
        singlePlan: "Single Plan",
        workPlanNotRecord: "No work plan record found.",
        workPlanInfo: "Work Plan Info",
        workPlanModel: "Work Plan Model",
        newWorkPlan: "New Work Plan",
        defaultWorkPlanModel: "Default Work Plan Model",
        workGroupModel: "Work Group Model",
        hourBasedPlanningModel: "Hour Based Planning Model",
        freelanceModelWithHourlyInterval: "Freelance Model With Hourly Interval",
        plan1Title: "Standard work and rotating shifts",
        plan1Description: "Create plan details by entering day-based time intervals.",
        plan2Title: "Places with unscheduled alternating shifts",
        plan2Description: "Provides automatic detection by grouping the created work plans.",
        plan3Title: "Merchandising sector",
        plan3Description: "Just plan in and out times and tolerances to apply.",
        plan4Title: "Places with no time limit",
        plan4Description: "Plan by entering total hours of work and break time.",
        details: "Details",
        settings: "Settings",
        plan: "Plan",
        calculateBasedOnFirstEntryAndLastExit: "Calculate based on first entry and last exit (calculations in between are not based)",
        shortCode: "Short Code",
        workPlanName: "Work Plan Name",
        entryTime: "Entry Time",
        exitTime: "Exit Time",
        tolerances: "Tolerances",
        earlyEntryTolerance: "Early Entry Tolerance",
        earlyExitTolerance: "Early Exit Tolerance",
        lateEntryTolerance: "Late Entry Tolerance",
        lateExitTolerance: "Late Exit Tolerance",
        mealBreakTime: "Meal Break",
        mealStartTime: "Meal Start",
        mealEndTime: "Meal End",
        totalMealTime: "Total Meal Time",
        totalWorkTime: "Total Work Time",
        breakTolerances: "Break Tolerances",
        createSettingsForDeservedBreaks: "Create settings for deserved breaks.",
        forHourlyWork: "for hourly work",
        break: "break",
        hourlyWork: "Hourly Work",
        breakTolerance: "Break Tolerance",
        notRecord: "Not record.",
        durationOfAbsence: "Duration of Absence",
        skipTheDayTime: "Skip The Day Time",
        solsticeTime: "Solstice Time",
        maxLimit: "Max Limit",
        minLimit: "Min Limit",
        basedOnEntryDay: "Based on entry day",
        checkTheDoors: "Check the doors",
        payrollDetails: "Payroll Details",
        toleranceToReduceTheSameMovementsToOne: "Tolerance to reduce the same movements to one",
        includeDifferentDoorsInDeleting: "Include different doors in deleting",
        dontDeleteConfirmedOvertimes: "Don't delete confirmed overtimes",
        selectThePlansYouWantToIncludeInTheGroup: "Select the plans you want to include in the group.",
        currentDefinitionBetweenSelectedHours: "Current definition between selected hours",
        whenItDoesntComePerceiveItAsADeserved: "When it doesn't come perceive it as a deserved",
        start: "Start",
        end: "End",
        payrollType: "Payroll Type",
        deserve: "Deserve",
        planType: "Plan Type",
        periodDistribution: "Period Distribution",
        periodStartDate: "Period Start Date",
        allowence: "Allowence",
        day: "Day",
        name: "Name",
        dayCount: "Day Count",
        isContinueWorkPlanUpdate: "Selected work plan will be updated. Continue?",
        isContinueWorkPlanSave: "New work plan will be saved. Continue?",
        isContinueWorkPlanDelete: "Selected work plan will be deleted. Continue?",
      },
      overtimeDefinitions: {
        overtimePlaces: "Overtime Places",
        overtimePlaceNotRecord: "No overtime place record found.",
        overtimeDescriptions: "Overtime Descriptions",
        overtimeDescriptionNotRecord: "No overtime description record found.",
        newOvertimePlaceDefinition: "New Overtime Place Definition",
        overtimePlaceName: "Overtime Place Name",
        overtimePlaceUpdate: "Update Overtime Place",
        isContinueOvertimePlaceDelete: "Selected overtime place will be deleted. Continue?",
        newOvertimeDescriptionDefinition: "New Overtime Description Definition",
        overtimeDescriptionName: "Overtime Description Name",
        overtimeDescriptionUpdate: "Update Overtime Description",
        isContinueOvertimeDescriptionDelete: "Selected overtime description will be deleted. Continue?",
      },
      allowences: {
        allowenceList: "Allowence List",
        allowenceNotRecord: "No allowence record found.",
        allowenceInfo: "Allowence Info",
        newAllowence: "New Allowence",
        shortCode: "Short Code",
        allowenceName: "Allowence Name",
        monthlyPayrollColumn: "Monthly Payroll Column",
        dailyPayrollColumn: "Daily Payroll Column",
        fullWorkTimeInDay: "Full Work Time In Day",
        color: "Color",
        isContinueAllowenceUpdate: "Selected allowence will be updated. Continue?",
        isContinueAllowenceSave: "New allowence will be saved. Continue?",
        isContinueAllowenceDelete: "Selected allowence will be deleted. Continue?",
      },
      inventoryManagement: {
        inventoryCategories: "Inventory Categories",
        inventoryCategoryInfo: "Category Information",
        newInventoryCategory: "New Category",
        inventoryCategoryName: "Category Name",
        inventoryCategoryList: "Category List",
        inventoryCategoryNotRecord: "No inventory category record found.",
        isContinueInventoryCategoryUpdate: "Selected inventory category will be updated. Continue?",
        isContinueInventoryCategorySave: "New inventory category will be saved. Continue?",
        isContinueInventoryCategoryDelete: "Selected inventory category will be deleted. Continue?",
        inventoryWarehouses: "Inventory Warehouses",
        inventoryWarehouseInfo: "Warehouse Information",
        newInventoryWarehouse: "New Warehouse",
        inventoryWarehouseName: "Warehouse Name",
        inventoryWarehouseList: "Warehouse List",
        inventoryWarehouseNotRecord: "No inventory warehouse record found.",
        isContinueInventoryWarehouseUpdate: "Selected inventory warehouse will be updated. Continue?",
        isContinueInventoryWarehouseSave: "New inventory warehouse will be saved. Continue?",
        isContinueInventoryWarehouseDelete: "Selected inventory warehouse will be deleted. Continue?",
        inventoryFieldList: "Inventory Fields",
        inventoryFieldInfo: "Inventory Field Information",
        newInventoryField: "New Inventory Field",
        inventoryFieldName: "Inventory Field Name",
        inventoryFieldNotRecord: "No inventory field record found.",
        isContinueInventoryFieldUpdate: "Selected inventory field will be updated. Continue?",
        isContinueInventoryFieldSave: "New inventory field will be saved. Continue?",
        isContinueInventoryFieldDelete: "Selected inventory field will be deleted. Continue?",
        inventoryList: "Inventory List",
        inventoryInfo: "Inventory Information",
        newInventory: "New Inventory",
        inventoryName: "Name",
        inventoryCode: "Code",
        inventorySerialNo: "Serial No",
        inventoryCategory: "Category",
        inventoryDefaultWarehouse: "Warehouse",
        quantity: "Quantity",
        documentType: "Document Type",
        documentDescription: "Document Description",
        newDocument: "New Document",
        editDocument: "Edit Document",
        deleteDocument: "Delete Document",
        addDocumentFile: "Add Document File",
        selectPhoto: "Select Photo",
        removePhoto: "Remove Photo",
        allCategories: "All Categories",
        inventoryNotRecord: "No inventory record found.",
        isContinueInventoryUpdate: "Selected inventory will be updated. Continue?",
        isContinueInventorySave: "New inventory will be saved. Continue?",
        isContinueInventoryDelete: "Selected inventory will be deleted. Continue?",
      },
      workPlaceDefinitions: {
        workPlaceList: "Work Place List",
        workPlaceNotRecord: "No work place record found.",
        workPlaceInfo: "Work Place Information",
        newWorkPlace: "New Work Place",
        workPlaceName: "Work Place Name",
        workPlaceUpdate: "Update Work Place",
        isContinueWorkPlaceUpdate: "Selected work place will be updated. Continue?",
        isContinueWorkPlaceSave: "New work place will be saved. Continue?",
        isContinueWorkPlaceDelete: "Selected work place will be deleted. Continue?",  
      },
      documentDefinitions: {
        documentDefinitionList: "Document List",
        documentDefinitionNotRecord: "No document record found.",
        documentDefinitionInfo: "Document Information",
        newDocument: "New Document",
        documentDefinitionName: "Document Name",
        documentDefinitionUpdate: "Update Document",
        isContinueDocumentDefinitionUpdate: "Selected document definition will be updated. Continue?",
        isContinueDocumentDefinitionSave: "New document definition will be saved. Continue?",
        isContinueDocumentDefinitionDelete: "Selected document definition will be deleted. Continue?",  
      },
      annualPermitGroups: {
        annualPermitGroupList: "Annual Permit Group List",
        annualPermitGroupNotRecord: "No annual permit group record found.",
        annualPermitGroupInfo: "Annual Permit Group Info",
        newAnnualPermitGroup: "New Annual Permit Group",
        groupName: "Group Name",
        start: "Start",
        end: "End",
        deservedDay: "Deserved Day",
        annualPermitGroupDetailNotRecord: "No annual permit group detail record found.",
        isContinueAnnualPermitGroupUpdate: "Selected annual permit group will be updated. Continue?",
        isContinueAnnualPermitGroupSave: "New annual permit group will be saved. Continue?",
        isContinueAnnualPermitGroupDelete: "Selected annual permit group will be deleted. Continue?",
      },
      scenarios: {
        newScenario: "New Scenario",
        scenarioDetails: "Scenario Details",
        backToScenarios: "Back to Scenarios",
        scenarioRecordNotFound: "Scenario record not found."
      },
      devices: {
        searchDeviceInList: "Search device in list...",
        deviceList: "Device List",
        deviceNotRecord: "No device record found.",
        deviceInfo: "Device Info",
        newDevice: "New Device",
        deviceNumber: "Device No",
        serialNo: "Serial No",
        brand: "Brand",
        platform: "Platform",
        feature: "Feature",
        isPanel: "Panel",
        card: "Card",
        fingerprint: "Fingerprint",
        faceRecognition: "Face Recognition",
        hasAntipassback: "Antipassback",
        hasTimeZone: "Timezone",
        isRealTime: "Real Time Monitoring",
        isOnlineDevice: "Online Control",
        deviceName: "Device Name",
        ipAddress: "Ip Address",
        port: "Port",
        adminPassword: "Admin Password",
        deviceGroup: "Device Group",
        status: "Status",
        readerInformation: "Reader Informations",
        readerList: "Readers",
        newReader: "New Reader",
        selectedDeviceReaderNotFound: "No reader found for the selected device.",
        readerNo: "No",
        readerName: "Reader Name",
        inputName: "Input Name",
        isMainDoor: "Is Main Door",
        typeOfUse: "Type of use",
        access: "Access",
        pdks: "PDKS",
        diningHall: "Dining Hall",
        licencePlateRecognition: "Licence Plate Recognition",
        dormitoryDevice: "Dormitory Device",
        bellOrAlarm: "Bell or Alarm",
        readerStatus: "Status",
        entry: "Entry",
        exit: "Exit",
        readerInfo: "To save a reader, first save device or make a selection from the list.",
        isContinueDeviceUpdate: "Selected device will be updated. Continue?",
        isContinueDeviceSave: "New device will be saved. Continue?",
        isContinueDeviceDelete: "Selected device will be deleted. Continue?",
        isContinueReaderUpdate: "Selected reader will be updated. Continue?",
        isContinueReaderSave: "New reader will be saved. Continue?",
        isContinueReaderDelete: "Selected reader will be deleted. Continue?",
      },
      deviceOperations: {
        addTask: "Add Task",
        deviceNotRecord: "No device record found.",
        startTime: "Start Time",
        selectTask: "Select Task",
        getMovementLogs: "Get movement logs",
        personSetAndDelete: "Person set and delete",
        getPersons: "Get persons",
        sendBatchPersonData: "Send batch person data",
        updateTime: "Update time",
        restart: "Restart",
        removeAdminAuthorizes: "Remove admin authorizes",
        removeAllPerson: "Remove all person",
        sendAuthorityGroups: "Send authority groups",
        sendPlate: "Send plate",
        sendBatchPlates: "Send batch plates",
        repeatDaily: "Repeat Daily",
        applyRepeatDaily: "Apply repeat daily",
        repetitionInterval: "Repetition Interval",
        oneTimePerDay: "1 time per day",
        sendCommand: "Send Command",
        activeTaskList: "Active Task List",
        person: "Person",
        task: "Task",
        device: "Device",
        taskTime: "Task Time",
        repeatDay: "Repeat (daily)",
        noRepeat: "No Repeat",
        activeTaskNotRecord: "No active task record found.",
        isContinueTaskDelete: "Selected task will be deleted. Continue?"
      },
      companySettings: {
        companies: "Companies",
        newCompany: "New Company",
        companyNotRecord: "No company record found.",
        companyLogo: "Company Logo",
        selectPhoto: "Select Photo",
        visitorSettings: "Visitor Settings",
        cardIsNotUsedAccessGroup: "Card is Not Used, Access Group",
        cardIsUsedAccessGroup: "Card is Used, Access Group",
        companyInformation: "Company Information",
        companyName: "Company Name",
        companyTitle: "Company Title",
        phone: "Phone",
        webSite: "Web",
        address: "Address",
        syncRegistrationNoToDeviceNo: "Sync registration number to device number",
        isContinueCompanyUpdate: "Selected company will be updated. Continue?",
        isContinueCompanySave: "New company will be saved. Continue?",
        isContinueCompanyDelete: "Selected company will be deleted. Continue?"
      },
      users: {
        users: "Users",
        newUser: "New User",
        userNotRecord: "No user record found.",
        userPhoto: "User Photo",
        selectPhoto: "Select Photo",
        companyAuthorities: "Company Authorities",
        companyNotRecord: "No company record found.",
        userInformation: "User Information",
        userName: "Username",
        userTitle: "User Title",
        email: "Email",
        authorityGroup: "Authority Group",
        password: "Password",
        repeatPassword: "Repeat Password",
        realTimeMonitorGroup: "Real Time Monitor Group",
        activateSmsSystem: "Activate SMS System",
        phoneNumber: "Phone Number",
        visitorCardGroup: "Visitor Card Group",
        departmentNotRecord: "No department record found.",
        reportAuthorities: "Report Authorities",
        reportNotRecord: "No report record found.",
        isContinueUserUpdate: "Selected user will be updated. Continue?",
        isContinueUserSave: "New user will be saved. Continue?",
        isContinueUserDelete: "Selected user will be deleted. Continue?",
        realTimeMonitorGroups: "Real Time Monitor Groups",
        realTimeMonitorGroupList: "Real Time Monitor Group List",
        newRealTimeMonitorGroup: "New Real Time Monitor Group",
        realTimeMonitorGroupNotRecord: "No real time monitor group record found.",
        groupName: "Group Name",
        deviceNotRecord: "No device record found.",
      },
      userAuthorityGroups: {
        userAuthorityGroupList: "User Authority Group List",
        userAuthorityGroupNotRecord: "No user authority group record found.",
        userAuthorityGroupInformation: "User Authority Group Information",
        newAuthorityGroup: "New Authority Group",
        authorityGroupName: "Authority Group Name",
        description: "Description",
        admin: "Admin",
        user: "User",
        authorityInfo: "If no selection is made, it will have full authority.",
        authorities: "Authorities",
        filterAuthorities: "Filter Authorities",
        fullAuthority: "Full Authority",
        onlyView: "Only View",
        cantUse: "Can't Use",
        isContinueUserAuthGroupUpdate: "Selected authority group will be updated. Continue?",
        isContinueUserAuthGroupSave: "New authority group will be saved. Continue?",
        isContinueUserAuthGroupDelete: "Selected authority group will be deleted. Continue?",
      },
      mailSmsSettings: {
        mailSettings: "Mail Settings",
        smsSettings: "SMS Settings",
        automaticMailList: "Automatic Mail List",
        mailDetails: "Mail Details",
        newMailDefinition: "New Mail Definition",
        mailDefinitionName: "Definition Name",
        mailHeader: "Mail Header",
        mailContent: "Mail Content",
        reportType: "Report Type",
        mailSendingTime: "Sending Time",
        day: "Day",
        time: "Time",
        reportsToSubmit: "Reports to Submit",
        byCustomFilter: "By Custom Filter",
        emailAddressesToSend: "Email Addresses to Send",
        enterAEmail: "Enter a email",
        filterGroup: "Current Filter Group",
        byAuthorizedEmployees: "By Authorized Employees",
        authorizedEmployees: "Authorized Employees",
        smsAPIRecordInformation: "SMS API Record Information",
        requestSentLink: "Request Sent Link",
        title: "Title",
        apiKey: "API Key",
        secretKey: "Secret Key",
        userName: "Username",
        password: "Password",
        smsSystem: "SMS System",
        active: "Active",
        dormitorySMSSettings: "SMS Settings",
        smsType: "SMS Type",
        smsContentDescription1: "The content to be sent when the student does not enter at the specified time",
        smsContentDescription2: "Content to be sent when a student checks in late",
        smsContentDescription3: "Content to be sent when student logs out without permission",
        smsContentDescription4: "Content that informs parents when student is allowed",
        parameters: "Parameters",
        studentName: "Student Name",
        todaysDate: "Today's Date",
        movementDate: "Movement Date",
        movementTime: "Movement Time",
        allowenceStartDate: "Allowence Start Date",
        allowenceEndDate: "Allowence End Date",
        allowenceName: "Allowence Name",
        dormitorySMSTimePlan: "SMS Time Plan",
        lastEntryTime: "Last Entry Time",
        updateInformation: "Update Information",
      },
      userLogs: {
        user: "User",
        userLogList: "User Log List",
        userLogs: "User Logs",
        userName: "Username",
        logTime: "Log Time",
        logDescription: "Log Description",
        logNotRecord: "No log record found.",
      },
      payrollTypes: {
        payrollTypeList: "Payroll Type List",
        payrollTypeNotRecord: "No payroll type record found.",
        payrollTypeInfo: "Payroll Type Info",
        newPayrollType: "New Payroll Type",
        shortCode: "Short Code",
        payrollName: "Payroll Name",
        payrollType: "Payroll Type",
        payrolls: {
          normalWork: "Normal Work",
          weekendHoliday: "Weekend Holiday",
          publicHoliday: "Public Holiday",
          annualPermit: "Annual Permit",
          absenteeism: "Absenteeism",
          missingHour: "Missing Hour",
          allowence: "Allowence",
          overtime: "Overtime",
          break: "Break",
          nightOvertime: "Night Overtime"
        },
        otherPayrollType: "Other Payroll Type",
        equalPayrollType: "Equal Payroll Type",
        monthlyPayrollColumn: "Monthly Payroll Column",
        maxLimit: "Max Limit",
        multiplier: "Multiplier",
        confirmation: "Confirmation",
        confirmationRequired: "Confirmation Required",
        tolerances: "Tolerances",
        firstTolerance: "First",
        lastTolerance: "Last",
        totalTolerance: "Total",
        isContinuePayrollTypeUpdate: "Selected payroll type will be updated. Continue?",
        isContinuePayrollTypeSave: "New payroll type will be saved. Continue?",
        isContinuePayrollTypeDelete: "Selected payroll type will be deleted. Continue?",
      },
      monthlyPayrollTables: {
        monthlyPayrolColumnlList: "Monthly Payroll List",
        monthlyPayrollTableRecordNotFound: "No monthly payroll table record found.",
        monthlyPayrollInfo: "Monthly Payroll Info",
        newMonthlyPayroll: "New Monthly Payroll",
        shortCode: "Short Code",
        payrollColumnName: "Payroll Column Name",
        ssk: "SSK",
        total: "Total",
        work: "Work",
        isContinueMonthlyPayrollUpdate: "Selected monthly payroll will be updated. Continue?",
        isContinueMonthlyPayrollSave: "New monthly payroll will be saved. Continue?",
        isContinueMonthlyPayrollDelete: "Selected monthly payroll will be deleted. Continue?",
      },
      integration: {
        triggerTransfers: "Trigger Transfers",
      },
      support: {
        whatWouldYouLikeSupportOn: "What would you like support on?",
        subjectYouWantHelpWith: "Subject you want help with",
        searchResults: "Search Results",
        noRecordFound: "No record found."
      },
      guardTour: {
        guards: "Guards",
        newGuard: "New Guard",
        guardInfo: "Guard Info",
        nameSurname: "Name Surname",
        title: "Title",
        updatePassword: "Update Password",
        responsibleUserForGuard: "Responsible User for Guard",
        tourCalendar: "Tour Calendar",
        newCalendar: "New Calendar",
      }
    }),
  ]
})



// WEBPACK FOOTER //
// ./src/ml.js